export default Object.freeze({
  PORTUGUESE: "Portugués",
  ENGLISH: "Inglés",
  SPANISH: "Español",
  UPDATING_LANGUAGE_WAITING: "Cambiando el idioma, espere un momento",
  UNABLE_TO_ALTER_LANGUAGE: "No fue posible cambiar el idioma del programa.\n",
  MONITORING: "Protocolo",
  PHYS_MEDIUM: "Medio físico",
  GENERAL: "Generales",
  TS_EXPERT_DP: "TS Expert - Medio físico",
  LIVE_LIST: "Live List",
  OSCILLOSCOPE: "Osciloscopio",
  REPORT: "Informe",
  INFOS: "Información",
  RESUME: "Resumen",
  LOG: "Log",
  CONFIG: "Configuración",
  SAVE: "Guardar",
  REMOVE: "Eliminar",
  GOOD_STRING_ANALYZER_DN: "Bueno",
  BAD_STRING_ANALYZER_DN: "Malo",
  MASTER_STRING: "Maestro",
  NO_SIGNAL_STRING: "Sin señal",
  UNKNOWN_STRING: "Desconocido",
  ADDRESS: "Dirección",
  AMPLITUDE: "Amplitud",
  NOISE: "Ruido",
  SIGNAL: "Señal",
  STATUS: "Status",
  TURNED_ON: "Encendido ",
  TURNED_OFF: "Apagado ",
  SECOND: " segundo",
  TIME_INTERVAL_PLACEHOLDER: "0.0",
  BEFORE_MONITOR_INIT_STR: "Anterior a la última inicialización",
  LOG_WAITING: "Cargando datos del log",
  STATUS_CHANGE: "Cambio de estado: ",
  GENERATE_REPORT: "Generar informe",
  ANALYZER_VERSION: "1.2.0",
  REPORT_GENERATION: "- Generación de informe: ",
  GENERAL_REPORT: "Informe general – TS Monitor DeviceNet",
  DATA_REPORT: "Informe de datos – TS Monitor DeviceNet",
  CLIENT_INFO: "Informaciones del cliente",
  EXECUTING_COMPANY_INFO: "Informaciones de la empresa ejecutora",
  CONFORMITY: "Conformidad",
  REPORT_TYPE: "Tipo de informe",
  ANNOTATIONS: "Anotaciones",
  CONCLUSION: "Conclusión",
  DROPDOWN_PLACEHOLDER: "Elija una opción",
  PROJECT_NAME: "- Nombre del proyecto:",
  NETWORK_NAME: "- Nombre de la red:",
  LOCATION: "- Localización:",
  COMPANY_NAME: "- Nombre de la empresa:",
  ACCOUNTABLE_NAME: "- Nombre del responsable:",
  COMPANY_ADDRESS: "- Dirección:",
  COMPANY_CITY: "- Ciudad:",
  COMPANY_TEL: "- Teléfono:",
  EXECUTING_COMPANY_NAME: "- Nombre de la empresa:",
  EXECUTING_ACCOUNTABLE_NAME: "- Nombre del responsable:",
  EXECUTING_TEL: "- Teléfono:",
  EXECUTING_EMAIL: "- E-mail:",
  SUMMARY: "Índice",
  HARDWARE_VERSION: "Versión del hardware",
  ETHERNET_INFO: "Informaciones ETHERNET",
  LIVE_LIST_DOTS_ANALYZER_DN: "........................................................................................................................................",
  BAR_DOTS: ".........................................................................................................................",
  OSC_DOTS: "................................................................................................................................",
  LOG_DOTS: "................................................................................................................................................",
  DISCLAIMER_DOTS_ANALYZER_DN: "....................................................................................................................................",
  GENERATING_REPORT_WAITING: "Generando informe, por favor espere",
  GENERATING_REPORT_SUCCESS: "Informe generado con éxito. Para guardarlo, haga clic en Guardar informe abajo.",
  HORARY: "Horario",
  DESCRIPTION: "Descripción",
  END_OF_REPORT: "Fin del informe",
  DISCLAIMER_TEXT: "Los datos y valores mostrados en este informe son meramente auxiliares para el especialista en DeviceNet, de tal forma que cualquier indicación de corrección debe ser hecha por el usuario. Por esta razón, se recomienda que haya acompañamiento un ingeniero certificado en DeviceNet o técnico responsable por el análisis para certificar las informaciones prestadas por el producto. Por lo tanto Toledo & Souza se exime de qualquier responsabilidad, pérdidas o daños, directos o indirectos causados por las interpretaciones del software, no ofreciendo ninguna garantia en relación a la integridad, calidad o adecuación de la información proporcionada, pues dependen del análisis técnico de un profesional capacitado, y en su defecto, el usuario asumirá el riesgo de que el contenido sea inexacto, incompleto o no se ajuste a sus necesidades y requerimientos.",
  LOGIN: "LOGIN",
  LOGOUT: "Salir",
  TAGS: "Tags",
  SOFTWARE_UPDATE: "Actualización de Software",
  INTERFACE_CONFIG: "Configuraciones de la interfaz",
  CURRENT_VERSION: "Versión actual: ",
  UPDATE: "Actualizar",
  ALTER_LOGIN: "Cambiar login",
  INVALID_OR_CORRUPT_FILE: "El archivo no es válido o está corrompido.",
  LOGIN_CREDENTIALS_FAILURE: "Ocurrió un error al iniciar sesión: Nombre de usuario o contraseña incorrectos.",
  LOGIN_GENERAL_FALIURE: "Ocurrió un error al iniciar sesión:",
  GPG_ALERT_MESSAGE: "Solo es posible enviar archivos con extensión .gpg",
  SEND_FILE_SUCCESS: "El archivo fue enviado con éxito.",
  SEND_FILE_SUCCESS_WARNING: "No olvide verificar que la tarjeta de red de su computadora esté en la misma subred que del IP: ",
  SEND_FILE_FAILURE: "Ocurrió un error al cargar el archivo.",
  SEND_FILE_WAITING: "Enviando el archivo.",
  SEND_FILE_CORRUPTED_FILE: "El archivo de actualización se dañó durante el envío.",
  SEND_CONFIG_SUCCESS: "Las configuraciones han sido enviadas con éxito",
  SEND_CONFIG_FAILURE: "Ocurrió un error al enviar las configuraciones.",
  SEND_CONFIG_WAITING: "Enviando las configuraciones.",
  SEND_CONFIG_WAITING_2: "Terminando de enviar las configuraciones.",
  SEND_CONFIG_DONE: "Configuraciones enviadas.",
  START_MESSAGE_SUCCESS: "El monitor se iniciará en 15 segundos.",
  START_MESSAGE_FAILURE: "Ocurrió un error al iniciar el monitor.",
  STOP_MESSAGE_SUCCESS: "El monitor se detendrá en 15 segundos.",
  STOP_MESSAGE_FAILURE: "Ocurrió un error al detener el monitor.",
  RESET_TRAFFIC_SUCCESS: "Los valores se restablecerán a cero en el próximo escaneo.",
  RESET_TRAFFIC_FAILURE: "Ocurrió un error al borrar los incrementos de error.",
  RESET_DEVICES_SUCCESS: "Los datos del dispositivo se han borrado correctamente.",
  RESET_DEVICES_FAILURE: "Ocurrió un error al borrar los dadtos de los dispositivos.",
  CHANGE_USERNAME_SUCCESS: "El nombre de usuario se ha cambiado con éxito. Inicie sesión de nuevo.",
  CHANGE_USERNAME_FAILURE: "Ocurrió un error al cambiar el nombre de usuario:",
  USERNAME_TOO_SHORT: "El nombre de usuario debe contener al menos un carácter.",
  PASSWORD_MISSMATCH: "Las contraseñas ingresadas no coinciden",
  CHANGE_PASSWORD_SUCCESS: "La contraseña ha sido cambiada con éxito. Inicie sesión de nuevo.",
  CHANGE_PASSWORD_FAILURE: "Hubo un error al cambiar la contraseña: ",
  VERIFY_THE_FOLLOWING_INFO: "Por favor verifique la siguiente información:",
  INVALID_IP: "\n- La IP ingresada no es válida",
  INVALID_SUBMASK: "\n- La mascarilla ingresada no es válida",
  INVALID_GATEWAY: "\n- El gateway ingresado no es válido",
  INVALID_DNS: "\n- El DNS ingresado no es válido",
  LOOPBACK_IP_NTP: "\n- La IP de loopback (127.0.0.1) no se puede utilizar como IP del servidor NTP",
  EMPTY_WIFI_PWD: "\n- La contraseña wifi no puede estar vacía",
  SELECT_TIMEZONE: "\n- Es necesario seleccionar un Timezone para configurar el servidor NTP",
  ALTER_USERNAME: "CAMBIAR USUÁRIO",
  ALTER_PASSWORD: "CAMBIAR CONTRASEÑA",
  CONFIRM_RESTART_SYSTEM: "¿Está seguro de que desea reiniciar el sistema?",
  RESTART_SYSTEM_FAILURE: "Ocurrió un error al intentar reiniciar o sistema.",
  RESTART_SYSTEM_SUCCESS: "Solicitud de reinicio enviada con éxito. Espere aproximadamente 3 minutos para que el sistema se reinicie por completo.",
  SELECT_FILE: "Por favor seleciona un archivo para enviar",
  DO_NOT_CLOSE_THIS_TAB: "Deje esta pestaña abierta para seguir la actualización.",
  UPDATE_SUCCESS: "A actualización ha sido realizada com éxito!",
  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS: "Modifique al menos uno de los campos para actualizar la configuración de la interfaz.",
  REMEMBER_TO_UPDATE_BROWSER_ADDRESS_TO: "\nRecuerda actualizar la dirección en el navegador a: ",
  UPDATE_INTERFACE_CONFIG_SUCCESS: "¡La configuración de la interfaz ha sido actualizada con éxito!",
  ALTER: "Cambiar",
  NO: "No",
  YES: "Sí",
  NOTE: "Observación",
  TS_EXPERT_CONFIG_POPUP: "Permite habilitar/deshabilitar las no conformidades a ser reportadas por la herramienta.",
  SEND_NTP_CONFIG_WAITING: "Enviando las configuraciones del servidor NTP.",
  SEND_NTP_CONFIG_DONE: "Se han enviado las configuraciones del servidor NTP.",
  TURN_NTP_SERVER_ON: "Encender servidor NTP",
  PROCESSING_NTP_INIT: "Comenzando el procesamiento de las informaciones del servidor NTP.",
  PROCESSING_NTP_INFO: "Procesando las informaciones del servidor NTP.",
  PROCESSED_NTP_INFO: "Las informaciones del servidor NTP fureon procesadas.",
  PROCESSING_NTP_ERROR: "Ocurrió un error al enviar las informaciones al servidor NTP. Compruebe que la dirección IP del servidor sea correcta. Si es así, compruebe también si el servicio NTP está activado y vuelva a intentarlo.",
  NTP_INFO_TURNED_ON_SUCCESS: "El servidor NTP se ha conectado con éxito.",
  NTP_INFO_TURNED_ON_FAILURE: "Ocurrió un error al conectar el servidor NTP.",
  NTP_INFO_FAILURE: "No se pudo sincronizar con el servidor. Si el error persiste, póngase en contacto con el administrador del servidor NTP.",
  TURN_ON_DATE: "\nLa hora del servidor se ha actualizado a: ",
  MONITOR_WILL_BE_RESTARTED: "\nEl monitor ahora se reiniciará,",
  NTP_INFO_TURNED_OFF_SUCCESS: "El servidor NTP ha sido apagado con éxito.",
  NTP_INFO_TURNED_OFF_FAILURE: "Ocurrió un error al apagar el servidor NTP.",
  TURN_OFF_DATE: "\nTiempo de apagado: ",
  WAITING: "Aguarde un instante",
  CLEAN_LOG_SUCCESS: "El log ha sido limpiado con éxito.",
  CLEAN_LOG_FAILURE: "Ocurrió un error al borarar el log.",
  CLEAR: "Limpiar",
  INVALID_HOSTNAME: "El nombre de host no debe estar en blanco ni contener espacios o caracteres especiales.",
  HOSTNAME_CONFIG_SUCCESS: "El nombre de host se ha configurado con éxito.",
  HOSTNAME_CONFIG_ERROR: "Ocurrió un error al configurar el nombre de host",
  ADD_ALTER_TAGS: "Agregar/Editar Tags",
  CHOOSE_DEVICE: "Elija un dispositivo",
  NEW_TAG: "Nuevo Tag",
  REMOVE_ALL_TAGS: "Eliminar todos los Tags",
  CONFIRM_REMOVE_ALL_TAGS: "¿Está seguro de que desea eliminar los Tags de todos los dispositivos?",
  CHANGE_TAG_SUCCESS: "El Tag se cambió correctamente.",
  CHANGE_TAG_FAILURE: "Ocurrió un error al cambiar el Tag.",
  REMOVE_TAG_SUCCESS: "Los Tags se eliminaron correctamente.",
  REMOVE_TAG_FAILURE: "Ocurrió un error al eliminar los Tags.",
  IMPORT_TAGS_SUCCESS: "Los Tags se importaron correctamente.",
  IMPORT_TAGS_FAILURE: "Ocurrió un error al importar los Tags: ",
  PLEASE_SELECT_TAG_FILE: "Por favor seleccione un archivo de Tags.",
  SENDING_TS_EXPERT_CONFIG_WAITING: "Actualizando la configuración de TS Expert, espere un momento.",
  TS_EXPERT_CONFIG_SAVED_SUCCESSFULLY: "La configuración de TS Expert se ha guardado con éxito.",
  TS_EXPERT_CONFIG_SAVE_ERROR: "Ocorrió un error al guardar las configuraciones de TS Expert.",
  TS_EXPERT_CONFIGURATION: "Configuraciones del TS Expert",
  TS_EXPERT_POPUP_1: "Esta pestaña muestra la información de TS Expert.",
  TS_EXPERT_POPUP_3: "De forma automatizada, los equipos de mantenimiento, ingeniería y afines pueden obtener una lista de acciones con diferentes eventos, sus posibles causas, sugerencias de solución y los dispositivos en los que fueron detectados.",
  TS_EXPERT_POPUP_4: "El uso de TS Expert no excluye la necesidad de análisis humano, ni reemplaza dichas capacidades para crear correlaciones e interpretación de datos.",
  DETECTED_ON: "Detectado en: ",
  CHECK_YOUR_NETWORK: "Por favor verifica su red.",
  EXPORT_ACTIONS_LIST: "Exportar lista de aciones",
  GENERATING_ACTIONS_LIST_WAITING: "Generando PDF de lista de aciones, por favor espera.",
  GENERATING_ACTIONS_LIST_SUCCESS: "PDF generado con éxito. Para guardarlo, haga clic en Guardar lista de acciones.",
  ACTIONS: "Aciones",
  NO_PROBLEM_DETECTED: "El TS Expert no ha detectado ningún evento en la red.",
  NO_EVENTS_TO_BE_ANALYZED: "No hay eventos para analizar.",
  NO_EVENT_SELECTED: "Ningún evento selecionado",
  CHOOSE_AN_EVENT: "Elija un evento para ver las acciones sugeridas.",
  DETAILING: "Detalles",
  PROBLEM_CHECKED: "El evento ha sido conferido con éxito",
  PROBLEM_CHECK_ERROR: "Ocurrió un error al conferir el evento.",
  QUANTITY_DP: "Cantidad: ",
  PORT_IS_STILL_INACTIVE: "La puerta sigue inactiva",
  MARK_PROBLEM_AS_SOLVED: "¿Está seguro de que desea marcar el evento como conferido?",
  LAST_UPDATED: "Actualizado por la última vez en: ",
  THIS_COMPUTER_TIME: " (Tiempo de esta computadora)",
  UNKNOWN: "Desconocido",
  ATTENTION_SIGNAL_DOTS: "................................................",
  CAPACITIVE_EFFECT_DOTS: "............................................................................................................................",
  NO_TERMINATION_DOTS: "........................................................................................................",
  NO_POWER_SUPPLY_DOTS: "....................................................................................................",
  BAD_SIGNAL_DOTS: ".............................................................................",
  A_NOT_OK_DOTS: "...........................................................................................",
  B_NOT_OK_DOTS: "...........................................................................................",
  LONG_CABLE_DOTS: "..................................................................................................................................",
  NOISE_DOTS: "..............................................................................................................................................",
  REFLECTION_DOTS: "........................................................................................................",
  DEFORMED_WAVE_DOTS: ".......................................................................................................................",
  DEFORMED_WAVE_DOTS_2: ".........................................................................................................................",
  DUPLICATE_ADDRESS_DOTS: "..................................................................................................................",
  DUPLICATE_ADDRESS_DOTS_2: "....................................................................................................................",
  DISCLAIMER_EXPERT_DOTS: ".................................................................................................................................",
  DISCLAIMER_EXPERT_DOTS_2_ANALYZER_DN: "...................................................................................................................................",
  WLAN_CONFIG: "Configuraciones WLAN",
  CONNECTION_STATUS: "Estado de la conexión",
  WLAN_ADAPTER_ON: "Encendido",
  WLAN_ADAPTER_OFF: "Apagado",
  IP_PLACEHODLER_ANALYZER_DN: "192.168.2.210",
  SIGNAL_STRENGTH: "Fuerza de la señal",
  FREQUENCY: "Frecuencia",
  QUALITY: "Calidade",
  CHANNEL_PLACEHOLDER: "1",
  QUALITY_PLACEHOLDER: "Calidade",
  TURNING_WLAN_OFF_WAITING: "Apagando el adaptador WLAN, por favor espere.",
  TURNING_WLAN_ON_WAITING: "Encendendo el adaptador WLAN, por favor espere.",
  NETWORK: "Red",
  NETWORK_NAME_1: "Nombre de la red",
  SUBMASK: "Macarilla",
  PASSWORD: "Contraseña",
  WLAN_STATUS_POPUP_2: "Si está apagado, no es posible cambiar la configuración de WLAN.",
  WLAN_CONFIG_POPUP_1: "No es posible cambiar la configuración mientras el adaptador WLAN está apagado.",
  WLAN_CONFIG_POPUP_3: "Al cambiar la IP / mascarilla, si los campos aparecen en blanco después de la actualización, esto es una fuerte indicación de que:",
  WLAN_CONFIG_POPUP_4: "Ya hay otro dispositivo en la red con la misma IP;",
  WLAN_CONFIG_POPUP_5: "La mascarilla de red es muy estricta y no admite la IP que se pasó.",
  WLAN_ADAPTER_NOT_FOUND_4: "  • Si ninguna de las opciones anteriores resuelve el problema, comuníquese con Toledo e Souza.",
  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS_WLAN: "Modifique al menos uno de los campos para actualizar la configuración de WLAN.",
  UPDATE_WLAN_CONFIG_SUCCESS: "¡La configuración de WLAN ha sido actualizada con éxito!",
  SEND_WLAN_CONFIG_WAITING: "Enviando las configuraciones, por favor aguarde. Esto puede llevar cerca de um minuto.",
  LOADING_WAITING: "Cargando informaciones, por favor aguarde.",
  WLAN_INFO: "Informaciones WLAN",
  REASON_DP: "Razón: ",
  AVAILABILITY: "Disponibilidad",
  ACTIVE: "Activo",
  INACTIVE: "Inactivo",
  SEND_FILES_SUCCESS: "Los archivos han sido enviados con éxito.",
  SAME_SUBNET_IP_1: "\n- La dirección IP de la interfaz office no puede estar en la misma subred que la interfaz DeviceNet.",
  SAME_SUBNET_IP_2: "\n- La dirección IP de la interfaz DeviceNet no puede estar en la misma subred que la interfaz office.",
  SUBNET_OVERLAP_WLAN: "\n- El TS Monitor DeviceNet ha detectado que existe una superposición de direcciones entre la subred de la interfaz DeviceNet y la subred de la WLAN. Por este motivo, no es posible configurar la WLAN con la dirección IP y la máscara elegidas.",
  ZERO_IP_MSG: "\n- La dirección IP 0.0.0.0 no se puede utilizar como IP del monitor.",
  ZERO_IP_MASK_MSG: "\n- La IP 0.0.0.0 no se puede utilizar como mascarilla de red",
  BROADCAST_IP_MSG: "\n- La IP de broadcast no se puede utilizar como IP del monitor.",
  NETWORK_IP_MSG: "\n- La IP de la red no se puede utilizar como IP del monitor.",
  BROADCAST_GATEWAY_MSG: "\n- La IP de broadcast no se puede utilizar como IP de gateway.",
  NETWORK_GATEWAY_MSG: "\n- La IP de la red no se puede utilizar como IP de gateway.",
  THE_FOLLOWING_FILES_COULD_NOT_BE_SENT: "Ocurrió un error al enviar los siguientes archivos GSDML: ",
  THE_FOLLOWING_FILES_COULD_NOT_BE_REMOVED: "Ocurrió un error al remover los siguientes archivos GSDML: ",
  MANAGE: "Gestionar",
  IP_PLACEHODLER_PROTOCOL: "192.168.2.215",
  HOSTNAME_POPUP_1: "Un hostname debe tener entre 2 y 64 caracteres para ser válido.",
  HOSTNAME_POPUP_2: "Además, solo puede contener letras, números, puntos y guiones, y debe comenzar y terminar solo con letras y números.",
  INVALID_HOSTNAME_1: "El nombre de host debe tener entre 2 y 64 caracteres.",
  INVALID_HOSTNAME_2: "El nombre de host debe contener solo letras, números, puntos y guiones, y debe comenzar y terminar solo con letras y números.",
  SELECT_AT_LEAST_ONE_FILE_TO_DELETE: "Por favor selecione al menos un archivo para remover",
  MONITORING_INFO: "Informaciones del monitoreo",
  CONFORM_W_RESTRICTION_STRING: "Conforme con restriciones",
  NON_CONFORM_STRING: "No conforme",
  TS_MONITOR_VER_DP: "TS Monitor DeviceNet - Versión ",
  NETWORK_AVAILABILITY_DP: "Disponibilidad de la red: ",
  DEVICE_DATA: "Datos de los dispositivos",
  GRAPHIC_TOPOLOGY: "Topología gráfica",
  CONFIG_STRING: "Configuración",
  RESUME_DOTS: ".......................................................................................................................................",
  LIVE_LIST_DOTS_PROTOCOL: ".......................................................................................................................................",
  MON_LOG_DOTS: "..............................................................................................................................................",
  DISCLAIMER_DOTS_PROTOCOL: "...................................................................................................................................",
  M_MONITORING_LIVE_LIST_PAGE_TITLE: "1.2. Live List",
  M_MONITORING_LOG_PAGE_TITLE: "1.3. - Log de eventos",
  CONFIG_ERROR_STRING: "Error de configuración",
  FAULT_STRING: "Falla",
  CLASS_2: "",
  REMOVE_DEVICE_SUCCESS: "El dispositivo será eliminado en 30 segundos como máximo.",
  REMOVE_DEVICE_FAILURE: "Ocurrió un error al eliminar el dispositivo: ",
  WITH_DIAGNOSTIC_STRING: "Con diagnóstico",
  WITH_FAILURE_STRING: "Con falla",
  BILLIONS_OF: "Billón de",
  MILLIONS_OF: "Millón de",
  FAULTS_QUESTION_INFO: "Indica la cantidad de veces que un dispositivo DeviceNet no respondió a los mensajes enviados por TS Monitor.",
  GRAPHIC_TOPOLOGY_INPUT_PLACEHOLDER: "Buscar por IP, Tag o profiname",
  SAVE_TOPOLOGY_POS_STRING: "Guardar",
  DELETE_TOPOLOGY_POS_STRING: "Eliminar",
  EXPORT_TOPOLOGY: "Topología",
  IMPORT_TOPOLOGY: "Importar Topología",
  POSITION: "Posición",
  SAVE_TOPOLOGY_POS_SUCCESS_STRING: "El posicionamiento de la topología se guardó con éxito",
  SAVE_TOPOLOGY_POS_FAILURE_STRING: "Ocurrío el seguinte error al guardar el posicionamiento de la topología: ",
  DROP_TOPOLOGY_POS_SUCCESS_STRING: "El posicionamiento de la topología ha sido removida con éxito",
  DROP_TOPOLOGY_POS_FAILURE_STRING: "Ocurrío el seguinte error al remover el posicionamiento de la topología: ",
  ASK_REMOVE_POSITIONING: "¿Está seguro de que desea eliminar el posicionamiento guardado? Para confirmar la eliminación es necesario ingresar la información de inicio de sesión.",
  REMOVE_POSITIONING: "Remover posicionamiento",
  ALERT_CHOOSE_DEVICE_TYPE: "Por favor seleccione un tipo de dispositivo",
  ADD_DEVICE: "Añadir dispositivo",
  TAG_PLACEHOLDER: "TAG",
  DEVICE_DEFAULT_DROPDOWN_PLACEHOLDER: "Selecciona un tipo de dispositivo",
  ADD: "Añadir",
  LOCALE_DEL: "Eliminar seleccionado",
  LOCALE_BACK: "Volver",
  LOCALE_ADD_NODE: "Añadir dispositivo",
  LOCALE_ADD_EDGE: "Añadir conexión",
  LOCALE_EDIT_EDGE: "Editar conexión",
  LOCALE_ADD_DESCRIPTION: "Haga clic en un espacio en blanco para añadir un nuevo dispositivo",
  LOCALE_EDGE_DESCRIPTION: "Haz clic en un dispositivo y arrastra la conexión a otro dispositivo para conectarlos",
  LOCALE_EDIT_EDGE_DESCRIPTION: "Haz clic en los puntos de control y arrástralos a un dispositivo para conectarlos",
  LOCALE_CREATE_EDGE_ERROR: "No fue posible crear conexión a un clúster",
  LOCALE_DELETE_CLUSTER_ERROR: "Los clústeres no se pueden eliminar",
  LOCALE_EDIT_CLUSTER_ERROR: "Los clústeres no se pueden editar",
  TOPOLOGY_IMPORT_SUCCESS: "La topología fue importada con éxito!",
  ERROR_IMPORTING_GRAPHIC_TOPOLOGY: "Ocurrió un errro al importar la topología gráfica: ",
  PLEASE_SELECT_TOPOLOGY_FILE: "Por favor seleciona un archivo de topología.",
  CONFIG_DIAGNOSTIC_LIST_HEADER: "Diagnóstico",
  CONFIG_DIAGNOSTIC_LIST_CONTENT: "Si está activado, TS Expert registrará cada vez que un dispositivo DeviceNet tenga diagnóstico. El diagnóstico es una condición anormal o información de mal funcionamiento enviada por el dispositivo IO al controlador IO, solicitando mantenimiento o incluso reemplazo.",
  CONFIG_FAULT_LIST_HEADER: "Fallas",
  CONFIG_FAULT_LIST_CONTENT: "Si está activado, TS Expert registrará cada vez que un dispositivo DeviceNet tenga fallas. Esto indica que no responde a los comandos ping y arp a través de la red, es decir, no es accesible a través de la red.",
  DIAGNOSTIC_LIST_HEADER: "Hay dispositivos en la red que tienen diagnóstico.",
  DEVICE_WITH_DIAGNOSTIC: "Dispositivo con diagnóstico (Primera Detección)",
  DIAGNOSTIC_SUGGESTION_1: "Cuando un dispositivo tiene diagnóstico se sugiere:",
  DIAGNOSTIC_SUGGESTION_2: "Comprueba la información enviada por el propio IO Device (detectada y transformada en texto por el TS Monitor) e intente solucionar el problema. Si tiene dificultad para comprender el diagnóstico, comuníquese con el fabricante del dispositivo o consulte el manual del dispositivo IO para despejar sus dudas antes de una intervención.",
  DEVICE_WITH_FAULT: "Dispositivo con falla (Primera Detección)",
  FAULT_SUGGESTION_1: "Cuando un dispositivo tiene fallas se sugiere:",
  FAULT_SUGGESTION_2: "Verifique la alimentación del dispositivo IO;",
  FAULT_SUGGESTION_3: "Verifique que esté conectado físicamente a la red;",
  FAULT_SUGGESTION_4: "Verifique la integridad del conector;",
  FAULT_SUGGESTION_5: "Verifique la integridad del cable;",
  FAULT_SUGGESTION_6: "Verifica si el dispositivo ha perdido su dirección IP. En caso de que esto suceda, el dispositivo aparecerá en el monitor con la IP: 0.0.0.0, su IP también estará marcada en naranja en la Live List.",
  DEVICE_WITH_RETRIES_DOTS: "........................................................................................................",
  DEVICE_WITH_DIAGNOSTIC_DOTS: "..............................................................................................................",
  DEVICE_WITH_FAULT_DOTS: "...................................................................................................................",
  DEVICE_WITH_CONFIG_ERROR_DOTS: ".........................................................................................",
  DEVICE_WITH_ERROR_FRAME_DOTS: "....................................................................................................................................",
  DEVICE_WITH_PARAM_ERROR_DOTS: ".....................................................................................",
  DEVICE_MISSING_DOTS: ".......................................................................................................................",
  DEVICE_ONLINE_DOTS: "..........................................................................................................................",
  DEVICE_IS_CRITICAL_SLAVE_DOTS: "..................................................................................................",
  DEVICE_IS_MASTER_FAULT_DOTS: "...............................................................................................",
  DISCLAIMER_EXPERT_DOTS_1: "...................................................................................................................................",
  DISCLAIMER_EXPERT_DOTS_2_PROTOCOL: "......................................................................................................................................",
  ALL_EVENTS_CHECKED_SUCCESS: "Todos los eventos fueron revisados correctamente.",
  SIGNAL_QUALITY: "Calidad de la señal",
  SIGNAL_QUALITY_DESCRIPTION: "En la columna Señal siempre se considera el peor caso, para la amplitud media y mínima.",
  ATTENTION_PREVENTIVE_ACTION: "Atención - Acción preventiva",
  BAD_CORRECTIVE_ACTION: "Malo - Acción correctiva",
  ENABLE_DIAGNOSTIC: "Activar diagnóstico",
  ENABLE_DIAGNOSTIC_BIT: "Activar diagnóstico Bit ",
  INTERFACE_CONFIGURATION: "Configuración de interfaz",
  NEW_PASSWORD: "Nueva contraseña",
  REPEAT_PASSWORD: "Repetir contraseña",
  CLIENT_LOGO: "Logo del cliente",
  EXECUTING_COMPANY_LOGO: "Logo de la empresa ejecutora",
  TS_MONITOR_LOGO_ALT: "Logo de TS Monitor",
  HORARY_DETECTION: "Hora de detección",
  ERROR_FRAMES: "Tramas de error",
  USERNAME: "Usuario",
  TIMEZONE: "Zona horaria",
  FIXED_IP: "Dirección IP fija",
  TEST_NETWORK: "Red de teste",
  NOTE_ABBREVIATION: "Obs.",
  FORM_PROJECT_NAME: "Nombre del proyecto",
  FORM_NETWORK_NAME: "Nombre de la red",
  FORM_LOCATION: "Ubicación",
  FORM_COMPANY_NAME: "Nombre de la empresa",
  FORM_ACCOUNTABLE_NAME: "Nombre del responsable",
  FORM_ADDRESS: "Dirección",
  FORM_CITY: "Ciudad",
  FORM_PHONE: "Teléfono",
  DIAGNOSTIC: "Diagnósticos",
  ACTIONS_LIST: "Lista de aciones",
  TS_EXPERT_PROT: "TS Expert - Protocolo",
  LIVE_LIST_MATRIX: "Matriz",
  BAR_GRAPH: "gráfico de barras",
  TIME_ON_ANALYZER_DN: "Tiempo de análisis: ",
  ATTENTION_STRING: "Atención",
  LIVE_LIST_INPUT_TEXT_PLACEHOLDER_ANALYZER_DN: "Filtrar por dirección o signo",
  ADDRESSES: "Direcciones",
  AMPLITUDE_PRE: "amplitud del preámbulo",
  MEAN_AMPLITUDE: "amplitud media",
  MEAN_AMPLITUDE_N: "amplitud\npromedio",
  MIN_AMPLITUDE: "amplitud minima",
  MIN_AMPLITUDE_N: "amplitud\nmínimo",
  MAX_AMPLITUDE: "Sobresaliente",
  RATIO: "Razón",
  NETWORK_TAG: "Tag de segmento: ",
  IS_IN_SEGMENT: "pertenece a\n¿Segmento?",
  IS_IN_SEGMENT_1: "pertenece a",
  IS_IN_SEGMENT_2: "¿Segmento?",
  IS_IN_SEGMENT_DP: "Pertenece al Segmento: ",
  IS_IN_SEGMENT_QUESTION: "¿Pertenece al Segmento?",
  IS_IN_SEGMENT_LIVE_LIST_POPUP_1: "Indica si el dispositivo pertenece al mismo segmento que este TS Monitor DN.",
  IS_IN_SEGMENT_LIVE_LIST_POPUP_2: "Esta opción debe ajustarse manualmente para cada dispositivo en la pantalla de configuración.",
  MIN_AMPLITUDE_1: "amplitud",
  MIN_AMPLITUDE_2: "mínimo",
  MEAN_AMPLITUDE_1: "amplitud",
  MEAN_AMPLITUDE_2: "promedio",
  A: "un",
  B: "b",
  CHANNEL_A_PROBLEM: "Esta columna es un indicador de problemas en el canal A, cable verde, como por ejemplo:",
  CHANNEL_B_PROBLEM: "Esta columna es un indicador de problemas en el canal B, cable rojo, como por ejemplo:",
  MASTERS: "Maestros",
  SLAVES: "Dispositivos",
  AMPLITUDE_IDLE: "voltaje inactivo ",
  BAUD_RATE_KBPS: "BAUD RATE (Kbps)",
  BAUD_RATE_MBPS: "BAUD RATE (Mbps)",
  NETWORK_DATA: "Datos de red",
  MODAL_TITLE: "Formas de onda características",
  ANALYSIS_ERROR: "Se produjo un error al cambiar el estado del análisis.",
  ANALYSIS: "Análisis",
  ANALYZER: "TS Monitor DN ",
  DETECTED_PROBLEMS: "Problemas detectados:",
  INIT_PICO_NOT_FOUND: "TS Monitor DN no encontrado, conéctelo a la computadora.",
  MONGO_OFF: "TS Monitor DN detectó un error en su base de datos interna. Reinicie TS Monitor DN. Si el problema persiste, comuníquese con Toledo & Souza para obtener ayuda.",
  PICO_NOT_FOUND: "TS Monitor DN encontró un error interno que impidió que funcionara correctamente. Reinicie TS Monitor DN. Si el problema persiste, comuníquese con Toledo & Souza para obtener ayuda.",
  MONGO_REPAIR_SUCCESS: "¡Error solucionado exitosamente! Cierra el programa y vuelve a abrirlo para que los cambios surtan efecto.",
  MONGO_REPAIR_ERROR: "El problema no se pudo resolver. Póngase en contacto para obtener ayuda.",
  INIT_PICO_NOT_FOUND_PLAY: "Error al iniciar TS Monitor DN. Desconéctelo de su computadora, conéctelo nuevamente y reinicie el programa. Si el error persiste, reinicie su computadora e inténtelo nuevamente.",
  REPAIR: "Reparación",
  LOADING_ANALYZER: "Iniciando TS Monitor DN, espere.",
  NO_DP_ACTIVE_NETWORK: "TS Monitor DN no encontró una red activa, asegúrese de que esté conectada correctamente a una red DP DeviceNet e inténtelo nuevamente.",
  INVALID_SERIAL: "El número de serie no coincide con este TS Monitor DN. Reinstale el programa con un número de serie válido.",
  MONGO_OFF_POPUP: "Error al inicializar la base de datos, haga clic en el botón a continuación para solucionar el problema.",
  MEAN_AMPLITUDE_DESC: "Valor de amplitud medido entre el promedio de los puntos en un nivel lógico alto y el promedio de los puntos en un nivel lógico bajo, como se ilustra en la figura siguiente.",
  MEAN_AMPLITUDE_DESC_2: "Una amplitud promedio alta es indicativa de una falta de terminadores. Cuando este bajo indica: Resistencia en las conexiones; terminadores excesivos; cables prensados; cables doblados o doblados, etc.",
  AMPLITUDE_MIN_DESC: "Valor de amplitud entre el punto más pequeño de la forma de onda en un nivel lógico alto y el punto más grande en un nivel lógico bajo, como se ilustra en la figura siguiente.",
  AMPLITUDE_MIN_DESC_2: "Una gran diferencia entre la amplitud media y mínima indica: Reflexión (terminadores); mango largo; ruido; humedad en el autobús, etc.",
  OVERSHOOTING_DESC: "Valor de amplitud entre el valor promedio de la forma de onda en un nivel lógico alto y el punto más grande en un nivel lógico alto, como se ilustra en la figura siguiente.",
  OVERSHOOTING_DESC_2: "Indica: Falta de terminadores; conexiones en el medio del autobús; derivaciones, etc.",
  RATIO_DESC_1: "Relación entre los valores de amplitud mínima y amplitud media, para hacer evidente la degradación de la señal.",
  RATIO_DESC_2: "Cuanto más cerca de 1, mejor y cuanto más cerca de 0 (cero), peor será la calidad de la señal.",
  RATIO_FOMULA: "Relación = amperios. mínimo / amperios. promedio",
  IDLE_DESCRIPTION: " Período en el que la red está inactiva, es decir, el período entre una pregunta del maestro y la respuesta del dispositivo, o entre paquetes del maestro a sí mismo. El voltaje inactivo ideal es 1V, diferentes valores indican problemas en la red.",
  MONITOR_IP_NOT_FOUND: "Monitor IP no encontrado",
  SCAN_FAIL_FOUND: "TS Monitor DN ha perdido la conexión a la red DeviceNet, asegúrese de que esté correctamente conectado a la red. Después de realizar la conexión, reinicie TS Monitor DN.",
  GRAPH: "Gráfico",
  A_AND_B: "A y B",
  B_A: "B-A",
  WAVE_FORM: "Forma de onda",
  AMPLITUDE_A: "Amplitud A",
  AMPLITUDE_B: "Amplitud B",
  ADDRESS_DN: "Dirección: ",
  WAVE_A: "Señal A",
  WAVE_B: "Señal B",
  WAVE_DN: "DeviceNet señal",
  WAVE_PA: "señal megafonía",
  NANOSSECOND: "ns",
  MICROSSECOND: " µs",
  MILLISSECOND: " señora",
  TIME_NS: "Tiempo (ns)",
  TIME_US: "Tiempo (μs)",
  TIME_MS: "Tiempo (ms)",
  TIME_S: "Hora(s)",
  AMPLITUDE_PLACEHOLDER: "0,0 V",
  VOLTAGE: " V",
  VOLTAGE_PEAK_TO_PEAK: " V",
  CURSORS: "Cursores",
  CONTROLS: "Controles ",
  TIME_INTERVAL: " tiempo",
  CONTROLS_POPUP_TEXT: "Después de presionar PLAY, la forma de onda se actualiza aproximadamente cada 200 milisegundos.",
  CONTROLS_POPUP_TEXT_2: "Para liberar los controles, debes seleccionar la vista manual y elegir un dispositivo.",
  SIZE: "Tamaño ",
  VISUALIZATION: "Vista previa",
  AUTOMATIC: "Automático",
  MANUAL: "manuales",
  STD_WAVE_FORM: "Forma de onda estándar",
  LONG_CABLE_WAVE_FORM: "Forma de onda típica de cable largo",
  EXCESS_TERMINATIOR_WAVE_FORM: "Forma de onda excesiva del terminador típico",
  NO_SLAVE_WAVE_FORM: "Forma de onda típica de ausencia de dispositivo (dispositivos desconectados)",
  REFLECTION_WAVE_FORM: "Forma de onda típica con reflexión.",
  NO_TERMINATOR_WAVE_FORM: "Forma de onda típica del terminador faltante",
  FOR_MORE_INFO_DP: "Para información adicional, consulte Toledo & Souza o DeviceNet Directrices internacionales. Cabe mencionar que los eventos demostrados pueden ocurrir juntos, lo que cambia los patrones demostrados.",
  FEW_TERMINATOR_WAVE_FORM: "Forma de onda típica de un pequeño terminador.",
  WAVE_SIZE_DESC_1: "TS Monitor DN ya muestra el fotograma de dos maneras con solo 1 Byte o con 3 Bytes, de modo que aquí podemos verlo con un zoom mayor en 1 Byte o un zoom menor en 3 Bytes.",
  WAVE_SIZE_DESC_2: "Hay una excepción: el telegrama “E5” (acuse de recibo breve) siempre tiene solo 1 byte.",
  WAVE_SIZE_DESC_3: "A continuación se muestra un ejemplo en un marco con más de 1 y 3 Bytes.",
  TS_SCOPE_NOT_FINDING_ANSWER: "TS Monitor DN no encuentra una respuesta del dispositivo, por lo que los datos no están actualizados. La forma de onda siguiente es la última capturada por el sistema.",
  ORDER_BY: "Ordenar por",
  AMPLITUDE_ASC: "Amplitud creciente",
  AMPLITUDE_DESC: "Amplitud decreciente",
  ADDRESS_ASC: "dirección ascendente",
  VOLTAGE_V: "Voltaje (V)",
  VOLTAGE_V_PEAK_TO_PEAK: "Voltaje (V)",
  VOLTAGE_MV: "Voltaje (mV)",
  VOLTAGE_MV_PEAK_TO_PEAK: "Voltaje (mV)",
  ORDER: "Realizar pedidos",
  REFRESH_DATA: "Actualizar datos",
  LOADING: "Cargando",
  INSERT_VALID_ADDRESS_OR_TYPE: "Ingrese una dirección válida o un tipo de evento.",
  LOG_INPUT_TEXT_PLACEHOLDER_ANALYZER_DN: "Filtrar por dirección o tipo de evento",
  TYPE: "Tipo",
  ATTENTION_SIGNAL_LOG_DESCRIPTION: "El TS Expert detectó una señal con baja amplitud (estado de Señal en Atención).",
  NO_TERMINATION_LOG_DESCRIPTION: "TS Expert detectó una posible falta de terminador en el segmento al que está conectado.",
  NO_POWER_SUPPLY_LOG_DESCRIPTION: "TS Expert ha detectado una posible falta de alimentación en el terminador.",
  BAD_SIGNAL_LOG_DESCRIPTION: "El TS Expert detectó una señal de baja amplitud (mala señal).",
  A_NOT_OK_LOG_DESCRIPTION: "El TS Expert detectó un posible cortocircuito entre el conductor A y la malla de blindaje, o la masa puesta a tierra de un panel o dispositivo.",
  B_NOT_OK_LOG_DESCRIPTION: "El TS Expert detectó un posible cortocircuito entre el conductor B y la malla de blindaje, o la masa puesta a tierra de un panel o dispositivo.",
  LONG_CABLE_LOG_DESCRIPTION: "TS Expert detectó una posible condición de longitud del bus superior a la permitida.",
  REFLECTION_LOG_DESCRIPTION: "TS Expert detectó la presencia de reflexión en la forma de onda.",
  DEFORMED_WAVE_LOG_DESCRIPTION: "TS Expert detectó la presencia de una señal no estándar.",
  DUPLICATE_LOG_DESCRIPTION: "TS Expert detectó la posible presencia de dos dispositivos con la misma dirección en la red.",
  EVENT_CHECKED_SUCCESS_ANALYZER_DN: "El evento se llevó a cabo con éxito.",
  REPORT_EXPORT_NAME_ANALYZER_DN: "Informe TS Monitor DeviceNet - Medio físico",
  HEADER_TEXT_ANALYZER_DN: "Informe de datos - TS Monitor DeviceNet - Medio físico",
  ANALYZER_VERSION_STRING: "- Versión del monitor:",
  PROTOCOL: "- Protocolo:",
  PROTOCOL_TYPE: "DeviceNet",
  ANALYSIS_INIT: "- Inicio del seguimiento:",
  ANALYSIS_DURATION: "- Duración del seguimiento hasta la generación del informe: ",
  CONFORM: "según",
  CONFORM_W_RESTRICTION: "Cumple con las restricciones",
  NON_CONFORM: "No conforme",
  A_LIVE_LIST_PAGE_TITLE: "1. - Live List",
  A_OSCILLOSCOPE_PAGE_TITLE: "2.- Osciloscopio",
  A_BAR_GRAPH_PAGE_TITLE: "3.- Gráfico de barras",
  A_LOG_PAGE_TITLE: "4.- Log de eventos",
  B_LIVE_LIST_PAGE_TITLE: "2.1. - Live List",
  B_OSCILLOSCOPE_PAGE_TITLE: "2.2. - Osciloscopio",
  B_BAR_GRAPH_PAGE_TITLE: "2.3. - Gráfico de barras",
  B_LOG_PAGE_TITLE: "2.4. - Log de eventos",
  ANALYSIS_INFO: "Información de seguimiento",
  GENERATED_BY: "- Generado por TS Monitor DN",
  SOFTWARE_VERSION: "- Versión de software:",
  DATE_TIME: "- Fecha y hora:",
  BAUD_RATE_ANALYZER_DN: "- Velocidad de transmisión:",
  CYCLE_TIME_ANALYZER_DN: "- Tiempo de ciclo:",
  NUM_MASTERS: "- Maestrías:",
  NUM_SLAVES: "- Dispositivos:",
  AMPLITUDE_IDLE_1: "- Tensión inactiva:",
  REDE_TAG: "- Tag de red: ",
  IP_DN: "- IP: ",
  MASK_DN: "- Máscara: ",
  GATEWAY_DN: "- Puerta de enlace: ",
  NETWORK_NAME_DN: "- Nombre de la red: ",
  SELECT_REPORT_TYPE: "Por favor seleccione un tipo de informe",
  MASTER_DN: "Maestro: ",
  SLAVE_DN: "Dispositivo: ",
  SIGNAL_DN: "Señal: ",
  AMPLITUDE_DP: "Amplitud: ",
  AMPLITUDE_PRE_DP: "Amplitud del preámbulo: ",
  AMPLITUDE_MIN_DN: "Amplitud mínima: ",
  OVERSHOOTING_DP: "Adicional: ",
  AMPLITUDE_MAX_DP: "Amplitud máxima: ",
  MODEL: "modelo",
  GENERAL_INFORMATION: "Información general",
  LAST_200_EVENTS: "200 últimos eventos",
  DISCLAIMER: "Aviso legal",
  CAPTURE_TIME: "tiempo de captura",
  ENTER: "Iniciar sesión",
  RESTART_SYSTEM_ANALYZER_DN: "Reiniciar el sistema",
  IP: "IP",
  MASK: "máscara",
  GATEWAY: "Puerta de enlace",
  DNS: "DNS",
  TAG: "Tag",
  SETUP: "Configurar",
  EDIT: "Editar",
  ARE_YOU_SURE_ALTER_CONFIG_ANALYZER_DN: "¿Está seguro de que desea cambiar la configuración de Ethernet para TS Monitor DN?",
  IMPORT: "Importar",
  EXPORT: "Exportar",
  GPG_FILE_EXTENSION: ".gpg",
  SEND_FILE_WRONG_FILENAME_ANALYZER_DN: "Nombre no válido. El archivo de actualización debe llamarse: updateRMDP.tar.gz.gpg",
  CLEAN_STATISTICS_SUCCESS: "Las estadísticas se han borrado correctamente.",
  CLEAN_STATISTICS_FAILURE: "Se produjo un error al borrar las estadísticas.",
  RESET_RETRIES_SUCCESS: "Los reintentos se borraron exitosamente.",
  RESET_RETRIES_FAILURE: "Se produjo un error al borrar los reintentos.",
  LOOPBACK_IP_ANALYZER_DN: "\n- El loopback IP (127.0.0.1) no se puede utilizar como IP de TS Monitor DN",
  TAG_TOO_LONG_ANALYZER_DN: "\n- La longitud del Tag no puede exceder los 30 caracteres.",
  SYSTEM: "Sistema",
  RESTART: "Reiniciar",
  SELECT_GSD_FLIE: "Seleccione al menos un archivo GSD para enviar",
  SENDING_GSD_FILES: "Enviando archivos GSD",
  UPDATING_MONITOR_FILES_ANALYZER_DN: "Actualizando archivos en TS Monitor DN. Espere por favor.",
  MONITOR_FILES_UPDATED_SUCCESSFULLY_ANALYZER_DN: "Archivos actualizados, preparándose para reiniciar TS Monitor DN.",
  RESTARTING_MONITOR_WAIT_ANALYZER_DN: "Reiniciando TS Monitor DN, espere unos minutos.",
  UPDATE_ERROR_STRING_ANALYZER_DN: "Se produjo el siguiente error al actualizar TS Monitor DN: ",
  SCOPE_DP_IP_WAS_CHANGED_SUCCESSFULLY: "• El IP de TS Monitor DN se modificó correctamente.",
  NOTE_WAS_CHANGED_SUCCESSFULLY: "• La observación fue modificada exitosamente.",
  MONITOR_IP: "Monitorear IP",
  IN_SEGMENT_DEVICES: "Dispositivos de segmento",
  UPDATING_DATA: "Actualizando información, por favor espera",
  IN_SEGMENT_FORM_INPUT_PLACEHOLDER: "Filtrar dispositivos por dirección",
  IS_IN_SEGMENT_POPUP_DESCRIPTION_1: "Lista de dispositivos que pertenecen al mismo segmento que TS Monitor DN.",
  IS_IN_SEGMENT_POPUP_DESCRIPTION_2: "Si el dispositivo no está marcado en esta lista, significa que no pertenece al mismo segmento que TS Monitor DN.",
  IS_IN_SEGMENT_POPUP_DESCRIPTION_3: "Si no pertenece al mismo segmento, es posible que la forma de onda vista en el osciloscopio no coincida con la forma de onda real del dispositivo.",
  CONFIRM_ALTER_SEGMENT_DEVICES: "¿Está seguro de que desea realizar cambios en la lista de dispositivos que pertenecen al segmento?",
  ALTER_IS_IN_SEGMENT_LIST_FAILURE: "Se produjo un error al cambiar la lista de dispositivos del segmento.",
  ALTER_IS_IN_SEGMENT_LIST_SUCCESS: "¡La lista de dispositivos del segmento se ha cambiado correctamente!",
  NTP_SERVER: "Servidor NTP",
  TURN_NTP_SERVER_ON_QUESTION_ANALYZER_DN: "¿Está seguro de que desea activar el servidor NTP? Para hacer esto, será necesario reiniciar TS Monitor DN.",
  MONITOR_RESTART_SUCCESS_ANALYZER_DN: "TS Monitor DN se ha restablecido correctamente.",
  MONITOR_RESTART_FAILURE_ANALYZER_DN: "Se produjo un error al reiniciar TS Monitor DN.",
  ETHERNET: "Ethernet",
  ETHERNET_POPUP_1: "Campo de configuración de la interfaz Ethernet.",
  ETHERNET_POPUP_2_ANALYZER_DN: "Se utiliza para supervisión y acceso web a datos TS Monitor DN.",
  WLAN: "WLAN",
  WLAN_POPUP_1: "Campo de configuración de la interfaz inalámbrica, cuando el adaptador esté disponible.",
  WLAN_POPUP_2_ANALYZER_DN: "Se utiliza para supervisión y acceso web a datos TS Monitor DN.",
  TAG_CONFIG_ANALYZER_DN: "Tag de segmento: ",
  TAG_WAS_CHANGED_SUCCESSFULLY_ANALYZER_DN: "El Tag de TS Monitor DN se modificó correctamente.",
  TAG_CHANGE_FAILURE_ANALYZER_DN: "Se produjo un error al modificar el Tag de TS Monitor DN.",
  INVALID_MONITOR_IP: "El IP del monitor insertado no es válido.",
  MONITOR_IP_WAS_CHANGED_SUCCESSFULLY: "El IP del monitor se modificó correctamente.",
  MONITOR_IP_CHANGE_FAILURE: "Se produjo un error al modificar el IP del monitor.",
  MODE: "Modo",
  HIDDEN_SSID: "SSID oculto",
  OPTIONAL: " (Opcional)",
  ALTER_MONITOR_WLAN_CONFIG_ANALYZER_DN: "¿Está seguro de que desea cambiar la configuración de WLAN de TS Monitor DN?",
  CHANGE_IDLE_SIZE: "Cambiar tamaño inactivo",
  CHANGE_IDLE_SIZE_QUESTION_1: "Cambiar el tamaño inactivo reiniciará TS Monitor DeviceNet procedimientos internos. Este procedimiento puede tardar hasta 3 minutos.",
  CHANGE_IDLE_SIZE_QUESTION_2: "Al hacer clic en Sí, espere en la pantalla hasta que finalice. ¿Estás seguro de que quieres continuar?",
  CHANGE_PACKET_SIZE: "Cambiar tamaño de paquete",
  CHANGE_PACKET_SIZE_QUESTION_1: "Cambiar el tamaño del paquete reiniciará TS Monitor DeviceNet procedimientos internos. Este procedimiento puede tardar hasta 3 minutos.",
  CHANGE_PACKET_SIZE_QUESTION_2: "Al hacer clic en Sí, espere en la pantalla hasta que finalice. ¿Estás seguro de que quieres continuar?",
  IMPORT_TAGS: "Importar Tags",
  EXPORT_TAGS: "Exportar Tags",
  BAD_SIGNAL_LIST_HEADER: "Hay dispositivos en la red con mala señal.",
  BAD_SIGNAL: "Hay dispositivos en la red con mala señal.",
  DEVICE_BAD_SIGNAL: "Dispositivo con mala señal",
  BAD_SIGNAL_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará al usuario que la amplitud de la señal es mucho menor que la estándar (Mala Señal).",
  DN_ATTENTION_SIGNAL_LOG_DESCRIPTION: "El TS Expert detectó una señal con baja amplitud (estado de Señal en Atención).",
  DN_BAD_SIGNAL_LOG_DESCRIPTION: "El TS Expert detectó una señal de baja amplitud (mala señal).",
  ATTENTION_SIGNAL_LIST_HEADER: "Hay dispositivos en la red con señal en estado de alerta.",
  ATTENTION_SIGNAL: "Hay dispositivos en la red con señal en estado de alerta",
  DEVICE_ATTENTION_SIGNAL: "Dispositivo con señal de atención.",
  ATTENTION_SIGNAL_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará al usuario que la amplitud de la señal es inferior al estándar.",
  CAPACITIVE_EFFECT_LIST_HEADER: "Efecto capacitivo.",
  NOISE_LIST_HEADER: "Ruido.",
  NOISE_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará al usuario una posible condición de ruido en la red DeviceNet.",
  DEVICE_NOISE: "Dispositivo ruidoso",
  NOISE_LOG_DESCRIPTION: "TS Expert ha detectado una posible condición de ruido en la red DeviceNet.",
  CAPACITIVE_EFFECT: "Efecto capacitivo",
  DEVICE_CAPACITIVE_EFFECT: "Dispositivo con efecto capacitivo.",
  CAPACITIVE_EFFECT_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará al usuario una posible condición de una longitud de bus mayor a la permitida o un cambio en la impedancia.",
  CAPACITIVE_EFFECT_LOG_DESCRIPTION: "TS Expert ha detectado una condición de efecto capacitivo.",
  TS_EXPERT_REPORT_EXPORT_NAME_ANALYZER_DN: "Lista de acciones - TS Expert - TS Monitor DN",
  TS_EXPERT_POPUP_2_ANALYZER_DN: "Esta herramienta es un sistema experto desarrollado para optimizar y acelerar el análisis de las principales divergencias detectadas por TS Monitor DN en las redes DeviceNet.",
  TS_EXPERT: "TS Expert",
  EVENTS_LIST: "Lista de eventos",
  CHECKED: "Comprobado",
  BATCH_CHECK: "comprobar todo",
  INCREMENTS: "Incrementos",
  DEVICE: "Dispositivo",
  DEVICES: "Dispositivos",
  ATTENTION_SIGNAL_SUGGESTION_1: "Cuando la amplitud de la señal se encuentra en estado “atención”, se sugiere verificar:",
  ATTENTION_SIGNAL_SUGGESTION_2: "Si la red tiene más de dos terminadores conectados;",
  ATTENTION_SIGNAL_SUGGESTION_3: "Verificar la electrónica de los dispositivos, aislándolos individualmente del bus;",
  ATTENTION_SIGNAL_SUGGESTION_4: "Verifique si hay terminales sueltos en las conexiones de los terminales o en los conectores de los terminales;",
  ATTENTION_SIGNAL_SUGGESTION_5: "Compruebe si hay cables aplastados o dañados.",
  ATTENTION_SIGNAL_SUGGESTION_6: "Esta verificación se puede realizar con la red funcionando, sin embargo para cualquier intervención se recomienda esperar a que se detenga, ya que estos cambios pueden provocar la caída de la red.",
  BAD_SIGNAL_SUGGESTION_1: "Cuando la amplitud de la señal se encuentra en estado de “malo”, se sugiere verificar preventivamente:",
  BAD_SIGNAL_SUGGESTION_2: "Comprobar:",
  BAD_SIGNAL_SUGGESTION_3: "Si la red tiene más de dos terminadores conectados;",
  BAD_SIGNAL_SUGGESTION_4: "Verificar la electrónica de los dispositivos, aislándolos individualmente del bus;",
  BAD_SIGNAL_SUGGESTION_5: "Verifique si hay terminales sueltos en las conexiones de los terminales o en los conectores de los terminales;",
  BAD_SIGNAL_SUGGESTION_6: "Compruebe si hay cables aplastados o dañados.",
  BAD_SIGNAL_SUGGESTION_7: "Compruebe si hay cables aplastados, lo que aumentaría la resistencia del cable.",
  BAD_SIGNAL_SUGGESTION_8: "Esta verificación se puede realizar con la red funcionando, sin embargo para cualquier intervención se recomienda esperar a que se detenga, ya que estos cambios pueden provocar la caída de la red.",
  CAPACITIVE_EFFECT_SUGGESTION_1: "Cuando se detecta un efecto capacitivo se sugiere:",
  CAPACITIVE_EFFECT_SUGGESTION_1_REPORT: "Cuando se detecta efecto capacitivo:",
  CAPACITIVE_EFFECT_SUGGESTION_2: "Realice una inspección visual del segmento y compruebe si el bus es demasiado largo para la velocidad de transmisión actual (velocidad de comunicación).",
  CAPACITIVE_EFFECT_SUGGESTION_3: "Comprobar el estado del cableado y sustituir todo lo que no esté en buen estado.",
  NOISE_SUGGESTION_1: "Cuando exista ruido o mal aislamiento (fuga a tierra) se sugiere:",
  NOISE_SUGGESTION_2: "Este es uno de los problemas más complejos en las redes industriales. A continuación tenemos 4 consejos básicos que deberían ayudar a resolver este problema:",
  NOISE_SUGGESTION_3: "Verifique el aislamiento de las interfaces del dispositivo, una forma sencilla es desconectar una a una de la red y verificar si el problema persiste;",
  NOISE_SUGGESTION_4: "Para mitigar el ruido, es necesario verificar que todos los dispositivos de la red estén correctamente conectados a tierra;",
  NOISE_SUGGESTION_5: "Es necesario verificar la equipotencialización del sistema de puesta a tierra, una forma sencilla es verificar si existe corriente de fuga en los cables DeviceNet. Se espera un valor inferior a 100 mA;",
  NOISE_SUGGESTION_6: "Si tienes una corriente mayor a 100mA, un consejo es aislar la malla del dispositivo, manteniendo siempre el dispositivo conectado a tierra.",
  NOISE_SUGGESTION_7: "Si el problema persiste después de seguir estos consejos básicos, recomendamos buscar un especialista en redes DeviceNet.",
  ATTENTION_SIGNAL_PAGE_TITLE: ". - Señal en estado de atención.",
  NO_TERMINATION_PAGE_TITLE: ". - Segmento sin terminación",
  NO_POWER_SUPPLY_TERMINATION_PAGE_TITLE: ". - Terminador sin poder",
  BAD_SIGNAL_PAGE_TITLE: ". - Mala señal",
  A_NOT_OK_PAGE_TITLE: ". - Cortocircuito entre el conductor A y la malla.",
  B_NOT_OK_PAGE_TITLE: ". - Cortocircuito entre el conductor B y la malla.",
  CAPACITIVE_EFFECT_PAGE_TITLE: ". - Efecto capacitivo",
  NOISE_PAGE_TITLE: ". - Ruido o mal aislamiento (fuga a tierra)",
  REFLECTION_PAGE_TITLE: ". - Reflexión en la forma de onda.",
  DEFORMED_WAVE_PAGE_TITLE: ". - Señal deformada",
  DUPLICATE_PAGE_TITLE: ". - Dirección duplicada",
  SUGGESTION: "se sugiere",
  EVIDENCE: "evidencia",
  EVIDENCE_DESCRIPTION: "Captura de evidencia de incumplimiento reportado por TS Expert:",
  ATTENTION_SIGNAL_PAGE_DESCRIPTION: "TS Expert indica que la amplitud de la señal es inferior al estándar (estado de señal en atención).",
  NO_TERMINATION_PAGE_DESCRIPTION: "El TS Expert está indicando una posible ausencia de un terminador en el segmento al que está conectado.",
  NO_POWER_SUPPLY_PAGE_DESCRIPTION: "TS Expert indica una posible falta de energía en el terminador.",
  BAD_SIGNAL_PAGE_DESCRIPTION: "El TS Expert indica que la amplitud de la señal es mucho menor que la estándar (señal incorrecta).",
  A_NOT_OK_PAGE_DESCRIPTION: "El TS Expert indica un posible cortocircuito entre el conductor A y la malla de blindaje o la masa puesta a tierra de un panel o dispositivo.",
  B_NOT_OK_PAGE_DESCRIPTION: "El TS Expert indica un posible cortocircuito entre el conductor B y la malla de blindaje o la masa puesta a tierra de un panel o dispositivo.",
  CAPACITIVE_EFFECT_PAGE_DESCRIPTION: "El TS Expert está indicando una posible condición de un bus con una longitud mayor a la permitida o un cambio en la impedancia, cuyas causas típicas son flexiones excesivas, cables dañados, cables húmedos y dispositivos con problemas electrónicos.",
  NOISE_PAGE_DESCRIPTION: "TS Expert indica una posible condición de ruido en la red DeviceNet.",
  REFLECTION_PAGE_DESCRIPTION: "El TS Expert indica la presencia de reflexión en la forma de onda.",
  DEFORMED_WAVE_PAGE_DESCRIPTION: "TS Expert indica la presencia de una señal no estándar",
  DUPLICATE_PAGE_DESCRIPTION: "El TS Expert indica la posible presencia de una dirección duplicada.",
  WLAN_STATUS: "Adaptador WLAN",
  SSID: "SSID",
  CHANNEL: "canal",
  SSID_PLACEHOLDER: "SSID",
  MAC_PLACEHOLDER: "A0:8C:FD:19:DB:02",
  SIGNAL_STRENGTH_PLACEHOLDER: "90dBm",
  FREQUENCY_PLACEHOLDER: "2,4 GHz",
  ALTER_SCOPE_WLAN_CONFIG: "¿Está seguro de que desea cambiar la configuración de WLAN de TS Monitor DN?",
  CONNECTED: "Conectado",
  DISCONNECTED: "desconectado",
  WLAN_STATUS_POPUP_1_ANALYZER_DN: "Indica el estado del adaptador WLAN de TS Monitor DN.",
  CONNECTION_STATUS_POPUP_1_ANALYZER_DN: "Indica si TS Monitor DN está conectado o no a la red WLAN configurada.",
  WLAN_CONFIG_POPUP_2_ANALYZER_DN: "Se recomienda encarecidamente cambiar la configuración de WLAN solo al acceder a TS Monitor DN a través de la red cableada.",
  WLAN_ADAPTER_NOT_FOUND_1_ANALYZER_DN: "TS Monitor DN no pudo encontrar el adaptador WLAN:\n",
  WLAN_ADAPTER_NOT_FOUND_2_ANALYZER_DN: "  • Verifique si el adaptador está desconectado o tiene mal contacto;\n",
  WLAN_ADAPTER_NOT_FOUND_3_ANALYZER_DN: "  • Si el adaptador no está desconectado o tiene mal contacto, intente reemplazarlo;\n",
  MAC: "MAC",
  UPDATE_WLAN_CONFIG_ERROR_ANALYZER_DN: "No se puede conectar a la red WLAN. Si el problema persiste, intente reiniciar el enrutador TS Monitor DN o WLAN.",
  OK_STRING: "OK",
  IDLE_SIZE: "tamaño inactivo",
  PACKET_SIZE: "Tamaño del paquete",
  SMALL: "Pequeño",
  MEDIUM: "Medio",
  BIG: "grande",
  IDLE_SIZE_QUESTION_ICON_INFO: "El tamaño inactivo se refiere a la cantidad de puntos considerados al comienzo de la forma de onda de respuesta del dispositivo. Es posible configurar tres tamaños diferentes:",
  IDLE_SIZE_QUESTION_ICON_INFO_1: "Tamaño inactivo estándar (varía según la velocidad en baudios);",
  IDLE_SIZE_QUESTION_ICON_INFO_2: "Aumenta el tamaño en 1 bit;",
  IDLE_SIZE_QUESTION_ICON_INFO_3: "Aumenta el tamaño en 2 trazos de un bit.",
  PACKET_SIZE_QUESTION_ICON_INFO: "El tamaño del paquete es el número total de puntos capturados por TS Monitor DN en un único paquete de datos. Es posible configurar tres tamaños diferentes:",
  PACKET_SIZE_QUESTION_ICON_INFO_1: "Tamaño de paquete estándar (varía según la velocidad en baudios);",
  PACKET_SIZE_QUESTION_ICON_INFO_2: "Aumenta el tamaño del paquete en 100 puntos;",
  PACKET_SIZE_QUESTION_ICON_INFO_3: "Aumenta el tamaño del paquete en 200 puntos.",
  IDLE_SIZE_WAITING: "Al realizar procedimientos para cambiar el tamaño inactivo, espere en esta pantalla hasta que finalicen.",
  IDLE_SIZE_WAS_CHANGED_SUCCESSFULLY: "El tamaño inactivo se cambió correctamente",
  IDLE_SIZE_CHANGE_FAILURE: "Se produjo un error al cambiar el tamaño inactivo.",
  PACKET_SIZE_WAITING: "Realizando procedimientos para cambiar el tamaño del paquete, espere en esta pantalla hasta que finalicen.",
  PACKET_SIZE_WAS_CHANGED_SUCCESSFULLY: "El tamaño del paquete se cambió correctamente.",
  PACKET_SIZE_CHANGE_FAILURE: "Se produjo un error al cambiar el tamaño del paquete.",
  CHECK_MASTER: "Comprobar maestro",
  START_SEARCH_ERROR_MESSAGE: "Se produjo un error al iniciar la búsqueda de dispositivos. Por favor inténtalo de nuevo.",
  SEARCH_FINISH_SUCCESS: "¡La búsqueda de dispositivos se completó con éxito!",
  GET_DEVICES_LIST_ERROR: "Se produjo un error al cargar la lista de dispositivos.",
  IN_SEGMENT: "Actualmente en el segmento",
  POSSIBLY_IN_SEGMENT: "Identificado como perteneciente",
  POSSIBLY_OUT_OF_SEGMENT: "Se ha detectado que este dispositivo puede estar en otro hilo.",
  SEND_SEGMENT_DEVICES_INFO_SUCCESS: "¡La información sobre los dispositivos del segmento se ha enviado correctamente!",
  SEND_SEGMENT_DEVICES_INFO_ERROR: "Se produjo un error al enviar información sobre los dispositivos del segmento.",
  SEARCH: "Buscar",
  SEARCH_POPUP_1: "Para utilizar la parte DN Physical Media por primera vez, se recomienda seleccionar qué dispositivos pertenecen al segmento.",
  SEARCH_POPUP_2: "Presione el botón a continuación para buscar y encontrar todos los dispositivos accesibles en la red.",
  SEARCH_POPUP_3_1: "Después de la búsqueda, los dispositivos encontrados se agregarán a la lista de ",
  SEARCH_POPUP_3_2: "dispositivos disponibles",
  SEARCH_POPUP_3_3: " junto a. Dispositivos disponibles ",
  SEARCH_POPUP_3_4: "son todos aquellos encontrados, que pertenecen al segmento de red actual, o no.",
  SEARCH_POPUP_4_1: "La otra lista, de ",
  SEARCH_POPUP_4_2: "dispositivos seleccionados",
  SEARCH_POPUP_4_3: ", es la lista que ",
  SEARCH_POPUP_4_4: "contiene los dispositivos seleccionados por el usuario que está seguro de que están en el segmento de red actual.",
  SEARCH_POPUP_4_5: " Inicialmente esta lista estará vacía.",
  SEARCH_POPUP_5: "Una vez realizada la búsqueda, quedará en manos del usuario seleccionar cuáles de estos dispositivos realmente pertenecen al segmento de red, moviéndolos de la lista de dispositivos disponibles a la lista de dispositivos seleccionados.",
  SEARCH_POPUP_6_1: "NOTA: ",
  SEARCH_POPUP_6_2: "Los maestros de red siempre son monitoreados por TS Monitor DeviceNet, por lo tanto, no aparecen en esta página.",
  SAVE_POPUP_1_1: "Al hacer clic en el botón de abajo, los dispositivos en la lista ",
  SAVE_POPUP_1_2: "Dispositivos seleccionados",
  SAVE_POPUP_1_3: " será salvo.",
  SAVE_POPUP_2_1: "Al realizar este procedimiento, solo los dispositivos de la lista ",
  SAVE_POPUP_2_2: "Dispositivos seleccionados",
  SAVE_POPUP_2_3: " será monitoreado por el Ambiente Físico de la DN, y ",
  SAVE_POPUP_2_4: "sólo se mostrarán en las pantallas de Medios Físicos del DN, tales como: Live List, Matriz, Osciloscopio, etc.",
  EXPLANATION: "Explicación",
  SAVE_POPUP_3: "Esta funcionalidad es importante para identificar dispositivos que pertenecen al segmento de red DeviceNet. Esto reduce el tiempo de respuesta ya que el sistema verificará los dispositivos relevantes.",
  SAVE_POPUP_4: "También es de gran valor para que aquellos que tienen menos conocimiento de la red no busquen el problema en el segmento equivocado.",
  AVAILABLE_DEVICES: "Dispositivos disponibles",
  AVAILABLE_DEVICES_POPUP_1_1: "Esta lista contiene todos los dispositivos. ",
  AVAILABLE_DEVICES_POPUP_1_2: "encontrados en la red.",
  AVAILABLE_DEVICES_POPUP_2: "TS Monitor DeviceNet sugiere dispositivos que cree que pertenecen al segmento de red actual, indicándolos como: ",
  AVAILABLE_DEVICES_POPUP_2_1: " Identificado como perteneciente.",
  AVAILABLE_DEVICES_POPUP_3_1: "Haga clic en el botón ",
  AVAILABLE_DEVICES_POPUP_3_2: " mueve un dispositivo de la lista de ",
  AVAILABLE_DEVICES_POPUP_3_3: "dispositivos disponibles",
  AVAILABLE_DEVICES_POPUP_3_4: " a la lista de ",
  AVAILABLE_DEVICES_POPUP_3_5: "dispositivos seleccionados",
  AVAILABLE_DEVICES_POPUP_3_6: ", indicando que pertenece al segmento de red actual. Después de mover los dispositivos, debe hacer clic en el botón ",
  AVAILABLE_DEVICES_POPUP_3_7: "Guardar",
  AVAILABLE_DEVICES_POPUP_3_8: " para guardar estos cambios.",
  AVAILABLE_DEVICES_POPUP_4_1: "NOTA: ",
  AVAILABLE_DEVICES_POPUP_4_2: "Corresponde al usuario tomar la decisión final y decidir qué dispositivos pertenecen realmente al segmento.",
  LOADING_DEVICES: "Dispositivos de carga",
  MOVE_ALL: "mover todo",
  SELECTED_DEVICES: "Dispositivos seleccionados",
  SELECTED_DEVICES_POPUP_1_1: "Esta lista contiene todos los dispositivos que el usuario ha marcado como ",
  SELECTED_DEVICES_POPUP_1_2: "perteneciente al segmento de red actual.",
  SELECTED_DEVICES_POPUP_2_1: "Es importante tener en cuenta que después de hacer clic en el botón ",
  SELECTED_DEVICES_POPUP_2_2: "Guardar",
  SELECTED_DEVICES_POPUP_2_3: ", la parte de Entorno Físico DN ",
  SELECTED_DEVICES_POPUP_2_4: "solo monitoreará los dispositivos que estén en la lista de dispositivos seleccionados.",
  SELECTED_DEVICES_POPUP_3_1: "Esto significa que:",
  SELECTED_DEVICES_POPUP_3_2: " Los dispositivos que no estén en esta lista no se mostrarán en las pantallas de Medios Físicos de DN, como por ejemplo: Live List, Matriz, Osciloscopio, Gráfico de barras, etc.",
  CONFIRM_SEARCH_START: "¿Estás seguro de que quieres iniciar la búsqueda?",
  CONFIRM_SEARCH_START_POPUP_1_1: "El procedimiento de búsqueda del dispositivo tomará ",
  CONFIRM_SEARCH_START_POPUP_1_2: "5 (cinco) minutos",
  CONFIRM_SEARCH_START_POPUP_1_3: " por completar.",
  CONFIRM_SEARCH_START_POPUP_2_1: " durante la busqueda ",
  CONFIRM_SEARCH_START_POPUP_2_2: "Se reiniciarán varios procedimientos internos de TS Monitor DeviceNet.",
  CONFIRM_SEARCH_START_POPUP_2_3: ", y por esta razón, sólo volverá a funcionar normalmente una vez finalizada la búsqueda.",
  SEARCHING_DEVICES: "Buscando dispositivos.",
  PLEASE_STAY_IN_PAGE: "Permanezca en la página para seguir el progreso de la búsqueda.",
  SENDING_DEVICES_INFO: "Enviando información sobre dispositivos, por favor espere.",
  TIME_ON_PROTOCOL: "Tiempo encendido: ",
  NUM_OF_DEVICES: "Número de dispositivos",
  MISSING: "Ausente",
  STATISTICS: "Estadísticas",
  NO_RETRIES: "Sin reintentos",
  OCUP_BANDA: "OCUPACIÓN DE BANDA (%)",
  CYCLE_TIME_S: "TIEMPO(s) DEL CICLO",
  CYCLE_TIME_MS: "TIEMPO DE CICLO (ms)",
  MONITOR_TAG_STRONG: "TAG DE MONITOREO",
  WATCHDOG_MS: "PERRO VIGILANTE (ms)",
  RETRIES_LIMIT: "LÍMITE DE REINTENTOS",
  DEVICENET_NETWORK_INFO: "Información de red DeviceNet",
  HSA_POPUP_1: "HSA (Dirección DeviceNet más alta) es el parámetro que indica la dirección más alta en la que el maestro busca nuevos equipos en la red, utilizando el protocolo FDL_Status.",
  HSA_POPUP_2: "También se utiliza para detectar maestros de clase 2 o redes con más de un maestro.",
  LOST: "perdido",
  FALHA: "Fallos",
  RETRIE: "Reintentos",
  DIAGNOSTICS: "Diagnóstico",
  STATUS_DEVICE: "Estado",
  REASON: "\nRazón: ",
  MANUFACTURER_MODEL: "Fabricante/Modelo",
  ALTER_TAG_ERROR_REASON: ".\nRazón: ",
  ERROR_REASON: ".\nRazón: ",
  DN_CAPACITIVE_EFFECT_LOG_DESCRIPTION: "TS Expert ha detectado una condición de efecto capacitivo.",
  DN_NOISE_LOG_DESCRIPTION: "TS Expert ha detectado una posible condición de ruido en la red DeviceNet.",
  DN_DIAGNOSTIC_LOG_DESCRIPTION: "TS Expert diagnóstico detectado.",
  DN_FAULT_LOG_DESCRIPTION: "TS Expert detectó una falla.",
  DN_RETRIES_LOG_DESCRIPTION: "TS Expert reintentos detectados.",
  DN_ERROR_FRAME_LOG_DESCRIPTION: "TS Expert detectó un marco de error.",
  PROTOCOL_RETRIES_LOG_DESCRIPTION: "TS Expert detectó reintentos en el dispositivo.",
  PROTOCOL_ERROR_FRAME_LOG_DESCRIPTION: "TS Expert detectó un error frame en la red.",
  EVENT_CHECKED_SUCCESS_PROTOCOL: "El evento se borró exitosamente.",
  SEND_FILE_WRONG_FILENAME_PROTOCOL: "Nombre no válido. El archivo de actualización debe llamarse: updateDN.tar.gz.gpg",
  LOOPBACK_IP_PROTOCOL: "\n- El loopback IP (127.0.0.1) no se puede utilizar como IP del monitor.",
  TAG_TOO_LONG_PROTOCOL: "La longitud del Tag no puede exceder los 30 caracteres.",
  SUBNET_OVERLAP_ETHERNET_WLAN: "\n- TS Monitor DN detectó que existe una superposición de direcciones entre la subred de la interfaz ETHERNET y la subred WLAN. Por este motivo, no es posible configurar la interfaz ETHERNET con la dirección y máscara IP elegidas.",
  RESTART_SYSTEM_PROTOCOL: " Reiniciar el sistema",
  UPDATING_MONITOR_FILES_PROTOCOL: "Actualización de archivos en el monitor. Espere por favor.",
  MONITOR_FILES_UPDATED_SUCCESSFULLY_PROTOCOL: "Archivos actualizados, preparándose para reiniciar el monitor.",
  RESTARTING_MONITOR_WAIT_PROTOCOL: "Reiniciando el monitor, espere unos minutos.",
  UPDATE_ERROR_STRING_PROTOCOL: "Se produjo el siguiente error al actualizar el monitor: ",
  TAG_WAS_CHANGED_SUCCESSFULLY_PROTOCOL: "El Tag del monitor se ha modificado correctamente.",
  TAG_CHANGE_FAILURE_PROTOCOL: "Se produjo un error al modificar el Tag del monitor.",
  TAG_CONFIG_PROTOCOL: "Tag de red",
  ETHERNET_POPUP_2_PROTOCOL: "Se utiliza para supervisión y acceso web para monitorear datos.",
  WLAN_POPUP_2_PROTOCOL: "Se utiliza para supervisión y acceso web para monitorear datos.",
  TURN_NTP_SERVER_ON_QUESTION_PROTOCOL: "¿Está seguro de que desea activar el servidor NTP? Para hacer esto, será necesario reiniciar el monitor.",
  MONITOR_RESTART_SUCCESS_PROTOCOL: "El monitor se ha reiniciado exitosamente.",
  MONITOR_RESTART_FAILURE_PROTOCOL: "Se produjo un error al reiniciar el monitor.",
  UPDATE_WLAN_CONFIG_ERROR_PROTOCOL: "No se puede conectar a la red WLAN. Si el problema persiste, intente reiniciar el monitor o el enrutador WLAN.",
  ARE_YOU_SURE_ALTER_CONFIG_PROTOCOL: "¿Está seguro de que desea cambiar la configuración de TS Monitor DN?",
  SEND: "Enviar",
  GSD_FILES: "GSD archivos",
  ALTER_MONITOR_WLAN_CONFIG_PROTOCOL: "¿Está seguro de que desea cambiar la configuración WLAN del monitor?",
  WLAN_STATUS_POPUP_1_PROTOCOL: "Indica el estado del adaptador WLAN del monitor.",
  CONNECTION_STATUS_POPUP_1_PROTOCOL: "Indica si el monitor está conectado o no a la red WLAN configurada.",
  WLAN_CONFIG_POPUP_2_PROTOCOL: "Se recomienda encarecidamente cambiar la configuración de WLAN solo cuando se accede al monitor a través de una red cableada.",
  WLAN_ADAPTER_NOT_FOUND_1_PROTOCOL: "TS Monitor DeviceNet no pudo encontrar el adaptador WLAN:\n",
  WLAN_ADAPTER_NOT_FOUND_2_PROTOCOL: "  • Verifique si el adaptador está desconectado o tiene mal contacto;\n",
  WLAN_ADAPTER_NOT_FOUND_3_PROTOCOL: "  • Si el adaptador no está desconectado o tiene mal contacto, intente reemplazarlo;\n",
  ALTER_MONITOR_HOSTNAME_CONFIRM_1: "¿Está seguro de que desea cambiar el nombre de host?",
  ALTER_MONITOR_HOSTNAME_CONFIRM_2: "Para hacer esto, necesita reiniciar el monitor.",
  DISP_DIAG: "Dispositivo",
  DIAGNOSTIC1: "Diagnóstico 1",
  DIAGNOSTIC2: "Diagnóstico 2",
  DIAGNOSTIC3: "Diagnóstico 3",
  DIAGNOSTIC4: "Diagnóstico 4",
  DIAGNOSTIC5: "Diagnóstico 5",
  DIAGNOSTIC6: "Diagnóstico 6",
  DIAGNOSTIC7: "Diagnóstico 7",
  DIAGNOSTIC8: "Diagnóstico 8",
  DIAGNOSTIC_LIST: "Lista de diagnósticos",
  DATA_FIELD_PLACEHODLER: "Fecha",
  BIT1: "Bit 1:",
  BIT2: "Bit 2:",
  BIT3: "Bit 3:",
  BIT4: "Bit 4:",
  BIT5: "Bit 5:",
  BIT6: "Bit 6:",
  BIT7: "Bit 7:",
  BIT8: "Bit 8:",
  DIAG_SUCcESS_MSG: "El diagnóstico se cambió con éxito.",
  REMOVE_DIAG_FAILURE: "Se produjo un error al cambiar el diagnóstico y los Tags.",
  REMOVE_GSD_SUCCESS: "Los archivos GSD se eliminaron correctamente",
  REMOVE_GSD_FILES: "Administrar archivos GSD",
  REMOVING_GSD_FILES: "Eliminando archivos GSD",
  FILTER_GSD_FILES: "Filtrar archivos GSD",
  DeviceNet: "DeviceNet",
  REPORT_EXPORT_NAME_PROTOCOL: "Informe TS Monitor DeviceNet",
  HEADER_TEXT_PROTOCOL: "Informe de datos - TS Monitor DeviceNet - Protocolo",
  CONFORM_STRING: "según",
  TAG_NAME_DN: "- Tag de red: ",
  MONITOR_VERSION_DN: "- Versión del monitor: ",
  MONITOR_INIT_DN: "- Inicio del seguimiento: ",
  GENERATING_TIME_DN: "- Generación de informes: ",
  DURATION_SINCE_MON_BEGIN: "- Duración del seguimiento hasta la generación del informe: ",
  BAUD_RATE_PROTOCOL: "Velocidad de transmisión: ",
  CYCLE_TIME_PROTOCOL: "Tiempo de ciclo: ",
  OCUP_BANDA_DN: "Ocupación de ancho de banda (%): ",
  MASTERS_DN: "Maestros: ",
  SLAVES_DN: "Dispositivos: ",
  ONLINE_SLAVES_DP: "Dispositivos en línea: ",
  MISSING_DN: "Ausente: ",
  RETRIES_DN: "Reintentos: ",
  DIAGNOSTIC_DN: "Diagnóstico: ",
  FAULT_DN: "Fallos: ",
  ERROR_FRAME: "Error Frame: ",
  WATCHDOG_DP: "Perro guardián: ",
  RETRIES_LIMIT_DP: "Límite de reintentos: ",
  HSA_DP: "Cuenta de Seguro Social: ",
  MATRIX: "Matriz",
  M_MONITORING_RESUME_PAGE_TITLE: "1.1. - Resumen",
  PROTOCOL_RESUME_PAGE_TITLE: "1. - Resumen",
  PROTOCOL_LIVE_LIST_PAGE_TITLE: "2. Live List",
  PROTOCOL_LOG_PAGE_TITLE: "3. - Log de eventos",
  ONLINE_STRING: "En línea",
  MISSING_PLURAL_STRING: "Ausente",
  MISSING_SINGULAR_STRING: "Ausente",
  PARAM_ERROR_STRING: "Error de parametrización",
  GOOD_STRING_PROTOCOL: "OK",
  BAD_STRING_PROTOCOL: "Falla",
  DIAGNOSTIC_STRING: "Diagnóstico",
  CRITIC_SLAVE_STRING: "Dispositivo crítico",
  MASTER_FAULT_STRING: "maestro",
  SLAVE_MASTER_FAULT_STRING: "Maestro en fallo",
  MPI_STRING: "IPM",
  MPI_CSV_FAULT_STRING: "MPI fallido",
  MASTER_CLASS_2: "maestro",
  MASTER_OPERATE: "Maestro - operar",
  MASTER_SYNC: "Maestro - sincronización",
  MASTER_UNSYNC: "Maestro - desincronizar",
  MASTER_FREEZE: "Maestro - congelar",
  MASTER_UNFREEZE: "Maestro - descongelar",
  MASTER_CLEAR: "Maestro - claro",
  MASTER_OPERATE_CAPITAL: "Maestro - Operar",
  MASTER_SYNC_CAPITAL: "Maestro - Sincronización",
  MASTER_UNSYNC_CAPITAL: "Maestro - Dessincronizar",
  MASTER_FREEZE_CAPITAL: "Maestro - Congelar",
  MASTER_UNFREEZE_CAPITAL: "Maestro - Descongelar",
  MASTER_CLEAR_CAPITAL: "Maestro - Borrar",
  WITH_CRITICAL_SLAVE_STRING: "La red tiene dispositivos en estado crítico",
  WITH_MASTER_FAULT_STRING: "La red tiene maestros en falla",
  LIVE_LIST_INPUT_TEXT_PLACEHOLDER_PROTOCOL: "Filtrar por dirección o estado",
  LOG_INPUT_TEXT_PLACEHOLDER_PROTOCOL: "Filtrar por dirección y Tag",
  SLAVE_DIAGNOSTIC: "Diagnóstico del dispositivo:",
  NETWORK_EVENT: "Evento de red",
  MASTER_HASHTAG: "Maestro #",
  CONFIG_ERROR_1: "error ",
  CONFIG_ERROR_2: "configuración",
  PARAM_ERROR_1: "error ",
  PARAM_ERROR_2: "parametrización",
  LAST_EVENT: "Último evento: ",
  DIAGNOSTICS_STRING: "Diagnóstico",
  ERROR_FRAMES_STRING: "Error Frame (primera detección)",
  ERROR_FRAMES_UPDATE_STRING: "Error Frame",
  RETRIES_STRING: "Reintentos",
  NUM_OF_DEVICES_STRING: "Número de dispositivos",
  FAULTS_STRING: "Fallos",
  WATCHDOG_STRING: "perro guardián",
  BILLION_OF: "mil millones de",
  MILLION_OF: "Millones de",
  THOUSAND: "mil",
  LAST_EVENT_TOO_BIG_STRING: "Descripción muy larga, consulte el registro.",
  CRITICAL_SLAVE_EXPLANATION: "El monitor TS tiene una función automática de seleccionar dispositivos que tienen una cantidad excesiva de eventos e informa al usuario que este dispositivo es crítico para la red DeviceNet.",
  DIAGNOSTICS_QUESTION_INFO: " Indica el número de diagnósticos detectados en la red DeviceNet. Los diagnósticos indican condiciones de estado anormales del dispositivo, como cortocircuito, problema de energía, módulo faltante, etc.",
  RETRIES_QUESTION_INFO: "Indica la cantidad de veces que el maestro necesitó reenviar un mensaje a un dispositivo determinado después de no recibir respuesta. Suele indicar problemas en el entorno físico.",
  WATCHDOG_QUESTION_INFO_1: "El watchdog es el tiempo que espera el dispositivo después de perder la comunicación con el maestro hasta que cambia sus salidas a una condición segura.",
  WATCHDOG_QUESTION_INFO_2: "Este parámetro es enviado por el maestro a todos los dispositivos de la red, de forma individual, en su respectivo telegrama de parametrización.",
  WATCHDOG_QUESTION_INFO_3: "Si el tiempo del ciclo se acerca al del perro guardián, la red se vuelve más vulnerable.",
  WATCHDOG_QUESTION_INFO: "Indica si el watchdog del dispositivo está activo, inactivo o aún no ha sido parametrizado.",
  EDIT_TOPOLOGY_POS_STRING: "Editar",
  EXPORT_SVG: "SVG",
  ALERT_NOT_POSSIBLE_TO_EDIT: "No se pueden editar los datos maestros",
  ALERT_NOT_POSSIBLE_TO_EDIT_SCOPE: "No se pueden editar los datos TS Monitor",
  ALERT_NOT_POSSIBLE_TO_DELETE: "No es posible eliminar un dispositivo de la Live List",
  ALERT_CHOOSE_CONNECTION_TYPE: "Por favor seleccione un tipo de conexión",
  ADD_CONNECTION: "Agregar conexión",
  CONNECTION_DEFAULT_DROPDOWN_PLACEHOLDER: "Elija un tipo de conexión",
  EDIT_DEVICE: "Editar dispositivo",
  CANCEL: "Cancelar",
  MASTER_NAME: "maestro",
  SLAVE_NAME: "Dispositivo",
  SLAVE_PA_NAME: "Dispositivo",
  REPEATER_NAME: "repetidor",
  HUB_NAME: "Centro",
  JB_NAME: "Caja de conexiones",
  COUPLER_PROXY_NAME: "Acoplador/Proxy",
  FIBER_LINK_NAME: "Enlace de fibra",
  ACTIVE_TERMINATION_NAME: "Terminador activo",
  UNKNOWN_NAME: "Desconocido",
  TS_MONITOR_NAME: "TS Monitor",
  MPI_NAME: "IPM",
  LOCALE_EDIT: "Editar",
  LOCALE_EDIT_NODE: "Editar dispositivo",
  FORM_NO_DEVICE_FOUND_PREFIX: "El dispositivo de dirección ",
  FORM_NO_DEVICE_FOUND_SUFFIX: " no fue encontrado",
  INSERT_VALID_ADDRESS_OR_TAG: "Por favor ingresa una dirección o Tag válido",
  INSERT_VALID_ADDRESS0_TAG_OR_MODEL: "Por favor ingresa una dirección o Tag válido",
  POSITIONING_CONFLICT_1: "Hay un conflicto en la información de la dirección del dispositivo:",
  POSITIONING_CONFLICT_2: "\nDebido a esto, sus posiciones y conexiones volverán a su estado predeterminado.",
  POSITIONING_ANG_CONNECTIONS_RESET_SUCCESS: "Los compañeros y conexiones regresaron exitosamente al estado predeterminado",
  POSITIONING_ANG_CONNECTIONS_RESET_FAILURE: "Se produjo el siguiente error al devolver relaciones de posición y conexiones a su estado predeterminado: ",
  COLORS_LABELS: "Leyenda de color",
  LABEL_SLAVE_OK_MASTER_OP: ": Dispositivo correcto y maestro funcionando;",
  LABEL_MASTER_STOP_CLEAR: ": Maestro en PARAR / BORRAR;",
  LABEL_SLAVE_DIAG: ": Dispositivo en diagnóstico;",
  LABEL_SLAVE_N_MASTER_FAULT: ": Dispositivo en fallo y maestro en fallo;",
  LABEL_SLAVE_CONFIG_ERROR: ": Dispositivo con error de configuración;",
  LABEL_SLAVE_PARAM_ERROR: ": Dispositivo con error de parametrización;",
  LABEL_SLAVE_ONLINE: ": Dispositivo en línea;",
  LABEL_SLAVE_MISSING: ": Ausente;",
  LABEL_SLAVE_MASTER_FAULT: ": Dispositivo con maestro defectuoso;",
  LABEL_SLAVE_BLACKLIST: ": Dispositivo en lista negra;",
  LABEL_CRITICAL_SLAVE: ": Dispositivo crítico;",
  LABEL_MPI: ":IPM;",
  LABEL_NO_STATUS: ": Dispositivo sin estado.",
  DEVICE_TAG_NOT_FOUND: "No se encontró ningún dispositivo con el TAG: ",
  INSERT_VALID_ADDRESS_1_127: "Ingrese una dirección de dispositivo válida, entre 1 y 127.",
  DEVICE_WITH_ADDRESS: "El dispositivo de dirección ",
  WAS_SUCCESSFULLY_ADDED: " se ha agregado exitosamente.",
  WAS_SUCCESSFULLY_REMOVED: " ha sido eliminado exitosamente.",
  IS_ALREADY_IN_NETWORK: " Ya está en la red.",
  REMOVE_DEVICE_ERROR: "Se produjo el siguiente error al intentar quitar el dispositivo: ",
  TS_SCOPE_NOT_FOUND: "No se puede encontrar TS Monitor de IP:",
  INVALID_INSERTED_IP: "El IP ingresado no es válido",
  TS_SCOPE_FETCH_SUCCESS: "La recuperación de TS Monitor se realizó correctamente",
  CONFIG_RETRIES_LIST_HEADER: "Reintentos",
  CONFIG_RETRIES_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará todos los reintentos, por dispositivo.",
  CONFIG_FAULT_SEQUENCE_LIST_HEADER: "Secuencia de falla",
  CONFIG_FAULT_SEQUENCE_LIST_CONTENT: "Cuando esta opción está activada, TS Expert registrará todas las fallas que ocurrieron en secuencia en caso de fallas de varios dispositivos.",
  CONFIG_CONFIG_ERROR_LIST_HEADER: "Error de configuración",
  CONFIG_CONFIG_ERROR_LIST_CONTENT: "Cuando esta opción esté activada, TS Expert indicará todos los dispositivos que tienen un error de configuración.",
  CONFIG_ERROR_FRAME_LIST_HEADER: "Error Frame",
  ERROR_FRAME_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará la aparición de tramas de error.",
  CONFIG_PARAM_ERROR_LIST_HEADER: "Error de parametrización",
  CONFIG_PARAM_ERROR_LIST_CONTENT: "Cuando esta opción esté activada, TS Expert indicará todos los dispositivos que tengan un error de parametrización.",
  CONFIG_MISSING_LIST_HEADER: "Ausente",
  CONFIG_MISSING_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará todos los dispositivos faltantes.",
  CONFIG_ONLINE_LIST_HEADER: "Dispositivo en línea",
  CONFIG_ONLINE_LIST_CONTENT: "Cuando esta opción esté activada, TS Expert indicará todos los dispositivos en línea.",
  CONFIG_CRITICAL_SLAVE_LIST_HEADER: "Dispositivo crítico",
  CONFIG_CRITICAL_SLAVE_LIST_CONTENT: "Cuando esta opción está activada, TS Expert registrará todos los dispositivos críticos.",
  CONFIG_MASTER_FAULT_LIST_HEADER: "Maestro en fallo",
  CONFIG_MASTER_FAULT_LIST_CONTENT: "Cuando esta opción está activada, TS Expert indicará cuando TS Monitor no esté recibiendo DeviceNet tramas.",
  TS_EXPERT_REPORT_EXPORT_NAME_PROTOCOL: "Lista de acciones - TS Expert - DeviceNet",
  TS_EXPERT_POPUP_2_PROTOCOL: "Esta herramienta es un sistema experto desarrollado para optimizar y acelerar el análisis de las principales divergencias detectadas por TS Monitor en las redes DeviceNet.",
  RETRIES_LIST_HEADER: "Hay dispositivos en la red que tienen reintentos.",
  DEVICE_WITH_RETRIES: "Dispositivo con reintentos (Primera Detección)",
  DEVICE_UPDATE_WITH_RETRIES: "Dispositivo con reintentos",
  RETRIES_INITIAL_ERROR_MSG: "No fue posible verificar los eventos de los siguientes dispositivos, ya que aún tienen reintentos:\n",
  S_RETRIES_INITIAL_ERROR_MSG: "No se puede verificar el evento del dispositivo porque todavía tienen reintentos\n",
  RETRIES_SUGGESTION_1: "Cuando un dispositivo tiene reintentos se sugiere:",
  RETRIES_SUGGESTION_2: "Los reintentos indican la cantidad de veces que el maestro necesitó reenviar un mensaje a un dispositivo determinado después de no recibir respuesta, ya sea porque el dispositivo no respondió o porque la respuesta estaba corrupta (trama ilegal o incompleta), debido a ruido, bajo aislamiento en el dispositivo o en la infraestructura del bus.",
  RETRIES_SUGGESTION_3: "Verificar y corregir el montaje de las conexiones;",
  RETRIES_SUGGESTION_4: "Verifique si hay daños en el cable DeviceNet, como por ejemplo:",
  RETRIES_SUGGESTION_5: "Se dobla menos de 10 veces el radio del conductor;",
  RETRIES_SUGGESTION_6: "Cortes en el cable;",
  RETRIES_SUGGESTION_7: "Giros en el cable;",
  RETRIES_SUGGESTION_8: "Abolladuras en el cable.",
  RETRIES_SUGGESTION_9: "Estas disconformidades requieren la sustitución de la sección del cable (no es posible resolver la disconformidad desdoblando o desenrollando el cable);",
  RETRIES_SUGGESTION_10: "Verifique si hay cables de alimentación cerca de los cables DeviceNet. Los cables de datos deben estar lo más separados posible o en bandejas/conductos cerrados y puestos a tierra, siguiendo el mínimo indicado por los lineamientos según la clasificación del conductor eléctrico, norma EN50174;",
  RETRIES_SUGGESTION_11: "Mida la corriente de fuga en el cable con unos alicates adecuados. Si la medida es superior a 100mA, es necesario verificar la equipotencialización y el sistema de puesta a tierra;",
  RETRIES_SUGGESTION_12: "Comprobación de la calidad de la señal con el medio físico DeivceNet, que te dará consejos según las mediciones realizadas;",
  RETRIES_SUGGESTION_13: "Si ninguno de los elementos anteriores resuelve el problema y un dispositivo específico experimenta reintentos de forma aislada (solo un dispositivo específico experimenta reintentos), se sugiere reemplazar la interfaz de red del dispositivo.",
  RETRIES_SUGGESTION_14: "El único ítem que puede tener mejores resultados con la planta en funcionamiento es el ítem “e”, sin embargo el uso de un analizador debe realizarse con precaución ya que si la condición de la señal está demasiado comprometida podría provocar una caída de la red.",
  DEVICE_UPDATE_WITH_DIAGNOSTIC: "Dispositivo con diagnóstico",
  DIAGNOSTIC_INITIAL_ERROR_MSG: "No fue posible verificar los eventos de los siguientes dispositivos, ya que aún tienen diagnóstico:\n",
  S_DIAGNOSTIC_INITIAL_ERROR_MSG: "No se puede verificar el evento del dispositivo porque todavía tiene diagnósticos\n",
  DIAGNOSTIC_SUGGESTION_3: "Si un dispositivo presenta algún diagnóstico, revisa la información enviada e intenta solucionar el problema. Si tiene dificultades para comprender el diagnóstico, comuníquese con el fabricante del dispositivo para resolver sus dudas antes de una intervención;",
  DIAGNOSTIC_SUGGESTION_4: "El creciente número de diagnósticos sin datos de mantenimiento puede estar directamente relacionado con fallos del dispositivo, ya que cuando el equipo se comunica nuevamente se realiza un diagnóstico en conferencia, que verifica si el dispositivo está listo para intercambiar datos. Verifique si el número de diagnóstico está cerca del número de falla, en este caso siga la prueba de falla paso a paso.",
  FAULT_LIST_HEADER: "Hay dispositivos en la red que tienen fallas.",
  DEVICE_UPDATE_WITH_FAULT: "Dispositivo con falla",
  FAULT_INITIAL_ERROR_MSG: "No fue posible verificar los eventos de los siguientes dispositivos, ya que aún presentan fallas:\n",
  S_FAULT_INITIAL_ERROR_MSG: "No se puede verificar el evento del dispositivo porque todavía tiene fallas\n",
  ERROR_FRAME_MSG: "No fue posible comprobar el evento, ya que la red todavía tiene tramas de error.\n",
  ERROR_FRAME_LIST_HEADER: "Error Frame.",
  DEVICE_WITH_ERROR_FRAME: "Error Frame (primera detección)",
  DEVICE_WITH_UPDATE_ERROR_FRAME: "Error Frame",
  ERROR_FRAME_SUGGESTION_1: "Cuando se detecta un error frame en la red, sugerimos:",
  ERROR_FRAME_SUGGESTION_2: "El error frame indica que se envió un mensaje incorrecto, ya sea debido a la falta de bits en el mensaje, CRC incorrecto o la respuesta estaba corrupta (trama ilegal o incompleta).",
  ERROR_FRAME_SUGGESTION_3: "Verificar y corregir el montaje de las conexiones;",
  ERROR_FRAME_SUGGESTION_4: "Verifique si hay daños en el cable DeviceNet, como por ejemplo:",
  ERROR_FRAME_SUGGESTION_5: "Se dobla menos de 10 veces el radio del conductor;",
  ERROR_FRAME_SUGGESTION_6: "Cortes en el cable;",
  ERROR_FRAME_SUGGESTION_7: "Giros en el cable;",
  ERROR_FRAME_SUGGESTION_8: "Abolladuras en el cable.",
  ERROR_FRAME_SUGGESTION_9: "Estas disconformidades requieren la sustitución de la sección del cable (no es posible resolver la disconformidad desdoblando o desenrollando el cable);",
  ERROR_FRAME_SUGGESTION_10: "Verifique si hay cables de alimentación cerca de los cables DeviceNet. Los cables de datos deben estar lo más separados posible o en bandejas/conductos cerrados y puestos a tierra, siguiendo el mínimo indicado por los lineamientos según la clasificación del conductor eléctrico, norma EN50174;",
  ERROR_FRAME_SUGGESTION_11: "Mida la corriente de fuga en el cable con unos alicates adecuados. Si la medida es superior a 100mA, es necesario verificar la equipotencialización y el sistema de puesta a tierra;",
  ERROR_FRAME_SUGGESTION_12: "Comprobando la calidad de la señal con el medio físico DeviceNet, el cual te dará consejos según las mediciones realizadas;",
  ERROR_FRAME_SUGGESTION_13: "Si ninguno de los elementos anteriores resuelve el problema y un dispositivo específico experimenta reintentos de forma aislada (solo un dispositivo específico experimenta reintentos), se sugiere reemplazar la interfaz de red del dispositivo.",
  ERROR_FRAME_SUGGESTION_14: "El único ítem que puede tener mejores resultados con la planta en funcionamiento es el ítem “e”, sin embargo el uso de un analizador debe realizarse con precaución ya que si la condición de la señal está demasiado comprometida podría provocar una caída de la red.",
  MISSING_LIST_HEADER: "Faltan dispositivos en la red.",
  DEVICE_MISSING: "Dispositivo perdido",
  DEVICE_MISSING_UPDATE: "Dispositivo perdido",
  MISSING_INITIAL_ERROR_MSG: "No se pueden verificar los eventos de los siguientes dispositivos porque aún faltan:\n",
  S_MISSING_INITIAL_ERROR_MSG: "No se puede verificar el evento del dispositivo porque aún falta\n",
  MISSING_SUGGESTION_1: "Cuando falta un dispositivo se sugiere:",
  MISSING_SUGGESTION_2: "Ocurre cuando el maestro o DCS busca un dispositivo en la red pero no recibe una respuesta. Este dispositivo se configuró en el proyecto, pero no responde en la red o no está instalado. Sugerencia:",
  MISSING_SUGGESTION_3: "Verifique si el dispositivo declarado en el software maestro o DCS está conectado a la red y encendido.",
  MISSING_SUGGESTION_4: "No se recomienda dejar el master o SDCD buscando dispositivos que no se instalarán.",
  SIGNAL_QUALITY_GOOD_DESCRIPTION: "• Amplitud Media mayor o igual a 2Vpp.",
  ATTENTION_PREVENTIVE_ACTION_MINIMUM: "• Amplitud media mayor o igual a 1,5Vpp.",
  ATTENTION_PREVENTIVE_ACTION_MAXIMUM: "• Amplitud media inferior a 2Vpp.",
  BAD_CORRECTIVE_ACTION_DESCRIPTION: "• Amplitud media inferior a 1,5Vpp.",
  DIAGNOSTIC_BYTE: "BYTE DE DIAGNÓSTICO",
  CONFIGURE: "Configurar",
  EMAIL: "Correo electrónico",
  HOSTNAME: "Nombre de host",
  DHCP: "DHCP",
  AVAILABLE_DEVICES_PLACEHOLDER: "Dispositivos",
  OBSERVATION_ABBREVIATION: "NOTA",
  RELATIVE_TIME_YEAR: "{value} año",
  RELATIVE_TIME_YEARS: "{value} años",
  RELATIVE_TIME_MONTH: "{value} mes",
  RELATIVE_TIME_MONTHS: "{value} meses",
  RELATIVE_TIME_DAY: "{value} día",
  RELATIVE_TIME_DAYS: "{value} días",
  RELATIVE_TIME_HOUR: "{value} hora",
  RELATIVE_TIME_HOURS: "{value} horas",
  RELATIVE_TIME_MINUTE: "{value} minuto",
  RELATIVE_TIME_MINUTES: "{value} minutos",
  CHART_TIME_VALUE: "Tiempo: ",
  CHART_ADDRESS: "Dirección: ",
  CHART_LOCALE: "es",
  CHART_MONTHS: "enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre",
  CHART_SHORT_MONTHS: "ene|feb|mar|abr|may|jun|jul|ago|sept|oct|nov|dic",
  CHART_DAYS: "domingo|lunes|martes|miércoles|jueves|viernes|sábado",
  CHART_SHORT_DAYS: "dom|lun|mar|mié|jue|vie|sáb",
  CHART_EXPORT_SVG: "Descargar SVG",
  CHART_EXPORT_PNG: "Descargar PNG",
  CHART_EXPORT_CSV: "Descargar CSV",
  CHART_MENU: "Descargar",
  CHART_SELECTION: "Seleccionar",
  CHART_SELECTION_ZOOM: "Zoom de selección",
  CHART_ZOOM_IN: "Acercar",
  CHART_ZOOM_OUT: "Alejar",
  CHART_PAN: "Navegación",
  SAVE_REPORT: "Guardar informe",
  FINALIZING: "Finalizando...",
  ACTION_LIST_TITLE: "Lista de acciones - TS Monitor DN",
  SAVE_ACTION_LIST: "Guardar lista de acciones",
  CHART_RESET_ZOOM: "Restablecer zoom",
  GOOD_PREVENTIVE_ACTION_DESCRIPTION: "• Amplitud media mayor o igual a 2Vpp.",
  ATTENTION_PREVENTIVE_ACTION_DESCRIPTION_1: "• Amplitud media mayor o igual a 1,5Vpp.",
  ATTENTION_PREVENTIVE_ACTION_DESCRIPTION_2: "• Amplitud media menor que 2Vpp."
});
